/* Static data generated from TheCocktailDB
  drinks: a list of each cocktail with ingredients
  drink_names: a list of cocktails
  ingredients: a list of ingredients with cocktails they can make
  raw_ing: a list of ingredients

  functions that return the data
  myDrinks() 
  myIngredients() 
  myRaw_ing() 
  myDrink_names()

*/

var drinks = {
  "252": [
    "151 proof rum",
    "wild turkey"
  ],
  "747": [
    "kahlua",
    "baileys irish cream",
    "frangelico"
  ],
  "1-900-fuk-meup": [
    "absolut kurant",
    "grand marnier",
    "chambord raspberry liqueur",
    "midori melon liqueur",
    "malibu rum",
    "amaretto",
    "cranberry juice",
    "pineapple juice"
  ],
  "3 wise men": [
    "jack daniels",
    "johnnie walker",
    "jim beam"
  ],
  "3-mile long island iced tea": [
    "gin",
    "light rum",
    "tequila",
    "triple sec",
    "vodka",
    "coca-cola",
    "sweet and sour",
    "bitters",
    "lemon"
  ],
  "9 1/2 weeks": [
    "absolut citron",
    "orange curacao",
    "strawberry liqueur",
    "orange juice"
  ],
  "24k nightmare": [
    "goldschlager",
    "jägermeister",
    "rumple minze",
    "151 proof rum"
  ],
  "50/50": [
    "vanilla vodka",
    "grand marnier",
    "orange juice"
  ],
  "57 chevy with a white license plate": [
    "creme de cacao",
    "vodka"
  ],
  "69 special": [
    "gin",
    "7-up",
    "lemon juice"
  ],
  "110 in the shade": [
    "lager",
    "tequila"
  ],
  "151 florida bushwacker": [
    "malibu rum",
    "light rum",
    "151 proof rum",
    "dark creme de cacao",
    "cointreau",
    "milk",
    "coconut liqueur",
    "vanilla ice-cream"
  ],
  "155 belmont": [
    "dark rum",
    "light rum",
    "vodka",
    "orange juice"
  ],
  "410 gone": [
    "peach vodka",
    "coca-cola"
  ],
  "501 blue": [
    "blue curacao",
    "blueberry schnapps",
    "vodka",
    "sour mix",
    "7-up"
  ],
  "747 drink": [
    "vodka",
    "roses sweetened lime juice",
    "cranberry juice",
    "sprite"
  ],
  "a1": [
    "gin",
    "grand marnier",
    "lemon juice",
    "grenadine"
  ],
  "a day at the beach": [
    "coconut rum",
    "amaretto",
    "orange juice",
    "grenadine"
  ],
  "a furlong too late": [
    "light rum",
    "ginger beer",
    "lemon peel"
  ],
  "a gilligan's island": [
    "vodka",
    "peach schnapps",
    "orange juice",
    "cranberry juice"
  ],
  "a midsummernight dream": [
    "vodka",
    "kirschwasser",
    "strawberry liqueur",
    "strawberries",
    "schweppes russchian"
  ],
  "a night in old mandalay": [
    "light rum",
    "añejo rum",
    "orange juice",
    "lemon juice",
    "ginger ale",
    "lemon peel"
  ],
  "a piece of ass": [
    "amaretto",
    "southern comfort",
    "ice",
    "sour mix"
  ],
  "a splash of nash": [
    "cranberry juice",
    "soda water",
    "midori melon liqueur",
    "creme de banane"
  ],
  "a true amaretto sour": [
    "amaretto",
    "lemon",
    "ice",
    "maraschino cherry"
  ],
  "a. j.": [
    "applejack",
    "grapefruit juice"
  ],
  "a.d.m. (after dinner mint)": [
    "white creme de menthe",
    "southern comfort",
    "vodka",
    "hot chocolate"
  ],
  "abbey cocktail": [
    "gin",
    "orange bitters",
    "orange",
    "cherry"
  ],
  "abbey martini": [
    "gin",
    "sweet vermouth",
    "orange juice",
    "angostura bitters"
  ],
  "abc": [
    "amaretto",
    "baileys irish cream",
    "cognac"
  ],
  "abilene": [
    "dark rum",
    "peach nectar",
    "orange juice"
  ],
  "absinthe #2": [
    "vodka",
    "sugar",
    "anise",
    "licorice root",
    "wormwood"
  ],
  "absolut evergreen": [
    "absolut citron",
    "pisang ambon",
    "ice",
    "bitter lemon"
  ],
  "absolut limousine": [
    "absolut citron",
    "lime juice",
    "ice",
    "tonic water"
  ],
  "absolut sex": [
    "absolut kurant",
    "midori melon liqueur",
    "cranberry juice",
    "sprite"
  ],
  "absolut stress #2": [
    "absolut vodka",
    "peach schnapps",
    "coconut liqueur",
    "cranberry juice",
    "pineapple juice"
  ],
  "absolut summertime": [
    "absolut citron",
    "sweet and sour",
    "sprite",
    "soda water",
    "lemon"
  ],
  "absolutely cranberry smash": [
    "absolut vodka",
    "cranberry juice",
    "ginger ale",
    "ice"
  ],
  "absolutely fabulous": [
    "vodka",
    "cranberry juice",
    "champagne"
  ],
  "absolutly screwed up": [
    "absolut citron",
    "orange juice",
    "triple sec",
    "ginger ale"
  ],
  "acapulco": [
    "light rum",
    "triple sec",
    "lime juice",
    "sugar",
    "egg white",
    "mint"
  ],
  "ace": [
    "gin",
    "grenadine",
    "heavy cream",
    "milk",
    "egg white"
  ],
  "acid": [
    "151 proof rum",
    "wild turkey"
  ],
  "adam & eve": [
    "rum",
    "vodka",
    "tequila",
    "triple sec",
    "fruit",
    "ice",
    "salt",
    "fruit juice"
  ],
  "adam bomb": [
    "rum",
    "vodka",
    "tequila",
    "triple sec",
    "fruit",
    "ice",
    "salt",
    "fruit juice"
  ],
  "adam sunrise": [
    "vodka",
    "lemonade",
    "water",
    "sugar"
  ],
  "adam": [
    "dark rum",
    "lemon juice",
    "grenadine"
  ],
  "addington": [
    "sweet vermouth",
    "dry vermouth",
    "soda water"
  ],
  "addison special": [
    "vodka",
    "grenadine",
    "orange juice"
  ],
  "addison": [
    "gin",
    "vermouth"
  ],
  "adios amigos cocktail": [
    "rum",
    "dry vermouth",
    "cognac",
    "gin",
    "fresh lime juice",
    "sugar syrup",
    "water"
  ],
  "adonis cocktail": [
    "sweet vermouth",
    "sherry",
    "orange bitters"
  ],
  "affair": [
    "strawberry schnapps",
    "orange juice",
    "cranberry juice",
    "club soda"
  ],
  "affinity": [
    "scotch",
    "sweet vermouth",
    "dry vermouth",
    "orange bitters"
  ],
  "after dinner cocktail": [
    "apricot brandy",
    "triple sec",
    "lime",
    "lime"
  ],
  "after five": [
    "peppermint schnapps",
    "kahlua",
    "baileys irish cream"
  ],
  "after sex": [
    "vodka",
    "creme de banane",
    "orange juice"
  ],
  "after supper cocktail": [
    "triple sec",
    "apricot brandy",
    "lemon juice"
  ],
  "afterglow": [
    "grenadine",
    "orange juice",
    "pineapple juice"
  ],
  "afternoon": [
    "kahlua",
    "baileys irish cream",
    "frangelico",
    "coffee",
    "cream"
  ],
  "alabama slammer": [
    "southern comfort",
    "amaretto",
    "sloe gin",
    "lemon juice"
  ],
  "alaska cocktail": [
    "orange bitters",
    "gin",
    "yellow chartreuse",
    "lemon peel"
  ],
  "alexander": [
    "gin",
    "creme de cacao",
    "light cream",
    "nutmeg"
  ],
  "alfie cocktail": [
    "lemon vodka",
    "triple sec",
    "pineapple juice"
  ],
  "algonquin": [
    "blended whiskey",
    "dry vermouth",
    "pineapple juice"
  ],
  "alice cocktail": [
    "grenadine",
    "orange juice",
    "pineapple juice",
    "cream"
  ],
  "alice in wonderland": [
    "amaretto",
    "grand marnier",
    "southern comfort"
  ],
  "allegheny": [
    "dry vermouth",
    "bourbon",
    "blackberry brandy",
    "lemon juice",
    "lemon peel"
  ],
  "allies cocktail": [
    "dry vermouth",
    "gin",
    "kummel"
  ],
  "almeria": [
    "dark rum",
    "kahlua",
    "egg white"
  ],
  "almond chocolate coffee": [
    "amaretto",
    "dark creme de cacao",
    "coffee"
  ],
  "almond joy": [
    "amaretto",
    "creme de cacao",
    "light cream"
  ],
  "aloha fruit punch": [
    "water",
    "ginger",
    "guava juice",
    "lemon juice",
    "pineapple",
    "sugar",
    "pineapple juice"
  ],
  "amaretto and cream": [
    "amaretto",
    "light cream"
  ],
  "amaretto fizz": [
    "amaretto",
    "orange juice",
    "white wine",
    "orange peel"
  ],
  "amaretto liqueur": [
    "sugar",
    "water",
    "apricot",
    "almond flavoring",
    "grain alcohol",
    "water",
    "brandy",
    "food coloring",
    "food coloring",
    "food coloring",
    "glycerine"
  ],
  "amaretto mist": [
    "amaretto",
    "lime"
  ],
  "amaretto rose": [
    "amaretto",
    "lime juice",
    "club soda"
  ],
  "amaretto shake": [
    "chocolate ice-cream",
    "brandy",
    "amaretto"
  ],
  "amaretto sour": [
    "amaretto",
    "sour mix"
  ],
  "amaretto stinger": [
    "amaretto",
    "white creme de menthe"
  ],
  "amaretto stone sour alternative": [
    "sour mix",
    "amaretto",
    "tequila",
    "orange juice"
  ],
  "amaretto stone sour": [
    "amaretto",
    "sour mix",
    "orange juice"
  ],
  "amaretto sunrise": [
    "amaretto",
    "orange juice",
    "grenadine"
  ],
  "amaretto sunset": [
    "triple sec",
    "amaretto",
    "cider",
    "ice"
  ],
  "amaretto sweet & sour": [
    "amaretto",
    "sweet and sour",
    "midori melon liqueur",
    "pineapple juice"
  ],
  "amaretto tea": [
    "tea",
    "amaretto",
    "whipped cream"
  ],
  "americano": [
    "campari",
    "sweet vermouth",
    "lemon peel",
    "orange peel"
  ],
  "angel face": [
    "apricot brandy",
    "apple brandy",
    "gin"
  ],
  "angelica liqueur": [
    "angelica root",
    "almond",
    "allspice",
    "cinnamon",
    "anise",
    "coriander",
    "marjoram leaves",
    "vodka",
    "sugar",
    "water",
    "food coloring",
    "food coloring"
  ],
  "apello": [
    "orange juice",
    "grapefruit juice",
    "apple juice",
    "maraschino cherry"
  ],
  "aperol spritz": [
    "aperol",
    "prosecco",
    "soda water"
  ],
  "apple berry smoothie": [
    "berries",
    "apple"
  ],
  "apple cider punch": [
    "apple cider",
    "brown sugar",
    "lemonade",
    "orange juice",
    "cloves",
    "allspice",
    "nutmeg",
    "cinnamon"
  ],
  "apple grande": [
    "tequila",
    "apple cider"
  ],
  "apple highball": [
    "lime",
    "apple schnapps",
    "cognac",
    "ginger"
  ],
  "apple karate": [
    "apple juice",
    "carrot"
  ],
  "apple pie with a crust": [
    "apple juice",
    "malibu rum",
    "cinnamon"
  ],
  "apple slammer": [
    "7-up",
    "apple schnapps"
  ],
  "applecar": [
    "applejack",
    "triple sec",
    "lemon juice"
  ],
  "applejack": [
    "jack daniels",
    "midori melon liqueur",
    "sour mix"
  ],
  "apricot lady": [
    "light rum",
    "apricot brandy",
    "triple sec",
    "lemon juice",
    "egg white",
    "orange"
  ],
  "apricot punch": [
    "apricot brandy",
    "champagne",
    "vodka",
    "7-up",
    "orange juice"
  ],
  "aquamarine": [
    "hpnotiq",
    "pineapple juice",
    "banana liqueur"
  ],
  "archbishop": [
    "gin",
    "wine",
    "benedictine",
    "lime"
  ],
  "arctic fish": [
    "vodka",
    "grape soda",
    "orange juice",
    "ice",
    "candy"
  ],
  "arctic mouthwash": [
    "maui",
    "mountain dew",
    "ice"
  ],
  "arise my love": [
    "champagne",
    "green creme de menthe"
  ],
  "arizona antifreeze": [
    "vodka",
    "midori melon liqueur",
    "sweet and sour"
  ],
  "arizona stingers": [
    "absolut vodka",
    "iced tea"
  ],
  "arizona twister": [
    "vodka",
    "malibu rum",
    "gold tequila",
    "orange juice",
    "pineapple juice",
    "cream of coconut",
    "grenadine",
    "ice",
    "pineapple"
  ],
  "army special": [
    "vodka",
    "gin",
    "lime juice cordial",
    "ice"
  ],
  "arthur tompkins": [
    "gin",
    "grand marnier",
    "lemon juice",
    "lemon peel"
  ],
  "artillery punch": [
    "tea",
    "rye whiskey",
    "red wine",
    "rum",
    "brandy",
    "benedictine",
    "orange juice",
    "lemon juice"
  ],
  "artillery": [
    "sweet vermouth",
    "gin",
    "bitters"
  ],
  "at&t": [
    "absolut vodka",
    "gin",
    "tonic water"
  ],
  "atlantic sun": [
    "vodka",
    "southern comfort",
    "passion fruit syrup",
    "sweet and sour",
    "club soda"
  ],
  "atomic lokade": [
    "lemonade",
    "vodka",
    "blue curacao",
    "triple sec",
    "sugar",
    "ice"
  ],
  "auburn headbanger": [
    "jägermeister",
    "goldschlager"
  ],
  "autodafé": [
    "vodka",
    "lime juice",
    "soda water"
  ],
  "autumn garibaldi": [
    "campari",
    "orange juice",
    "ginger beer",
    "orange peel"
  ],
  "avalanche": [
    "crown royal",
    "kahlua",
    "cream"
  ],
  "avalon": [
    "vodka",
    "pisang ambon",
    "apple juice",
    "lemon juice",
    "lemonade"
  ],
  "aviation": [
    "gin",
    "lemon juice",
    "maraschino liqueur"
  ],
  "aztec punch": [
    "lemonade",
    "vodka",
    "rum",
    "ginger ale"
  ],
  "b-52": [
    "baileys irish cream",
    "grand marnier",
    "kahlua"
  ],
  "b-53": [
    "kahlua",
    "sambuca",
    "grand marnier"
  ],
  "baby eskimo": [
    "kahlua",
    "milk",
    "vanilla ice-cream"
  ],
  "baby guinness": [
    "kahlua",
    "baileys irish cream"
  ],
  "bacardi cocktail": [
    "light rum",
    "lime juice",
    "sugar syrup",
    "grenadine"
  ],
  "bahama mama": [
    "rum",
    "dark rum",
    "banana liqueur",
    "grenadine",
    "pineapple juice",
    "orange juice",
    "sweet and sour"
  ],
  "bailey's dream shake": [
    "baileys irish cream",
    "vanilla ice-cream",
    "cream"
  ],
  "balmoral": [
    "scotch",
    "sweet vermouth",
    "dry vermouth",
    "bitters"
  ],
  "banana cantaloupe smoothie": [
    "cantaloupe",
    "banana"
  ],
  "banana cream pi": [
    "malibu rum",
    "banana liqueur",
    "pineapple juice"
  ],
  "banana daiquiri": [
    "light rum",
    "triple sec",
    "banana",
    "lime juice",
    "sugar",
    "cherry"
  ],
  "banana milk shake": [
    "milk",
    "orange juice",
    "sugar syrup",
    "banana"
  ],
  "banana strawberry shake daiquiri": [
    "strawberries",
    "banana",
    "apple juice"
  ],
  "banana strawberry shake": [
    "strawberries",
    "banana",
    "yoghurt",
    "milk",
    "honey"
  ],
  "barracuda": [
    "rum",
    "galliano",
    "pineapple juice",
    "lime juice",
    "prosecco"
  ],
  "bee's knees": [
    "gold rum",
    "orange juice",
    "lime juice",
    "triple sec"
  ],
  "belgian blue": [
    "vodka",
    "coconut liqueur",
    "blue curacao",
    "sprite"
  ],
  "bellini martini": [
    "ice",
    "vodka",
    "peach nectar",
    "peach schnapps",
    "lemon peel"
  ],
  "bellini": [
    "champagne",
    "peach schnapps"
  ],
  "bermuda highball": [
    "brandy",
    "gin",
    "dry vermouth",
    "carbonated water",
    "lemon peel"
  ],
  "berry deadly": [
    "everclear",
    "wine",
    "orange juice",
    "kool-aid"
  ],
  "between the sheets": [
    "brandy",
    "light rum",
    "triple sec",
    "lemon juice"
  ],
  "bible belt": [
    "southern comfort",
    "triple sec",
    "lime",
    "sour mix"
  ],
  "big red": [
    "irish cream",
    "goldschlager"
  ],
  "bijou": [
    "orange bitters",
    "green chartreuse",
    "gin",
    "sweet vermouth"
  ],
  "black & tan": [
    "ale",
    "guinness stout"
  ],
  "black and brown": [
    "guinness stout",
    "root beer"
  ],
  "black forest shake": [
    "ice",
    "chocolate syrup",
    "cherry brandy",
    "vodka",
    "milk"
  ],
  "black russian": [
    "coffee liqueur",
    "vodka"
  ],
  "blackthorn": [
    "sweet vermouth",
    "sloe gin",
    "lemon peel"
  ],
  "bleeding surgeon": [
    "dark rum",
    "orange",
    "surge",
    "cranberry juice"
  ],
  "blind russian": [
    "baileys irish cream",
    "godiva liqueur",
    "kahlua",
    "butterscotch schnapps",
    "milk"
  ],
  "bloody maria": [
    "tequila",
    "tomato juice",
    "lemon juice",
    "tabasco sauce",
    "celery salt",
    "lemon"
  ],
  "bloody mary": [
    "vodka",
    "tomato juice",
    "lemon juice",
    "worcestershire sauce",
    "tabasco sauce",
    "lime"
  ],
  "bloody punch": [
    "vodka",
    "strawberries",
    "lime juice",
    "lemon-lime soda",
    "lemon-lime soda",
    "raisins",
    "blueberries"
  ],
  "blue hurricane": [
    "rum",
    "dark rum",
    "passoa",
    "blue curacao",
    "sweet and sour",
    "ice"
  ],
  "blue lagoon": [
    "vodka",
    "blue curacao",
    "lemonade",
    "cherry"
  ],
  "blue margarita": [
    "tequila",
    "blue curacao",
    "lime juice",
    "salt"
  ],
  "blue mountain": [
    "añejo rum",
    "tia maria",
    "vodka",
    "orange juice",
    "lemon juice"
  ],
  "blueberry mojito": [
    "dark rum",
    "lime juice",
    "sugar",
    "blueberries",
    "lemon-lime soda"
  ],
  "bluebird": [
    "gin",
    "triple sec",
    "blue curacao",
    "bitters",
    "maraschino cherry",
    "lemon peel"
  ],
  "bob marley": [
    "midori melon liqueur",
    "jägermeister",
    "goldschlager"
  ],
  "bobby burns cocktail": [
    "sweet vermouth",
    "scotch",
    "benedictine",
    "lemon peel"
  ],
  "bombay cassis": [
    "gin",
    "creme de cassis",
    "fresh lime juice",
    "ginger beer",
    "lime",
    "ginger"
  ],
  "boomerang": [
    "gin",
    "dry vermouth",
    "bitters",
    "maraschino liqueur",
    "maraschino cherry"
  ],
  "boozy snickers milkshake": [
    "vanilla ice-cream",
    "milk",
    "godiva liqueur",
    "whipped cream",
    "caramel sauce",
    "chocolate sauce",
    "mini-snickers bars"
  ],
  "bora bora": [
    "pineapple juice",
    "passion fruit juice",
    "lemon juice",
    "grenadine"
  ],
  "boston sidecar": [
    "light rum",
    "brandy",
    "triple sec",
    "lime"
  ],
  "boston sour": [
    "blended whiskey",
    "lemon",
    "powdered sugar",
    "egg white",
    "lemon",
    "cherry"
  ],
  "boulevardier": [
    "campari",
    "sweet vermouth",
    "rye whiskey",
    "orange peel"
  ],
  "bounty hunter": [
    "rum",
    "coconut liqueur",
    "blueberries",
    "pineapple juice",
    "prosecco"
  ],
  "bourbon sling": [
    "sugar",
    "water",
    "lemon juice",
    "bourbon",
    "lemon peel"
  ],
  "bourbon sour": [
    "bourbon",
    "lemon juice",
    "sugar",
    "orange",
    "maraschino cherry"
  ],
  "boxcar": [
    "gin",
    "triple sec",
    "lemon juice",
    "grenadine",
    "egg white"
  ],
  "brain fart": [
    "everclear",
    "vodka",
    "mountain dew",
    "surge",
    "lemon juice",
    "rum"
  ],
  "brainteaser": [
    "sambuca",
    "erin cream",
    "advocaat"
  ],
  "bramble": [
    "gin",
    "lemon juice",
    "sugar syrup",
    "creme de mure"
  ],
  "brandon and will's coke float": [
    "vanilla ice-cream",
    "coca-cola",
    "bourbon"
  ],
  "brandy alexander": [
    "brandy",
    "creme de cacao",
    "light cream",
    "nutmeg"
  ],
  "brandy cobbler": [
    "sugar",
    "club soda",
    "lemon",
    "brandy",
    "maraschino cherry",
    "orange"
  ],
  "brandy flip": [
    "brandy",
    "egg",
    "sugar",
    "light cream",
    "nutmeg"
  ],
  "brandy sour": [
    "brandy",
    "lemon",
    "powdered sugar",
    "lemon",
    "cherry"
  ],
  "brave bull shooter": [
    "tequila",
    "tabasco sauce"
  ],
  "brigadier": [
    "hot chocolate",
    "green chartreuse",
    "cherry heering"
  ],
  "broadside": [
    "151 proof rum",
    "scotch",
    "bitters",
    "wormwood",
    "ice"
  ],
  "brooklyn": [
    "rye whiskey",
    "dry vermouth",
    "maraschino liqueur",
    "angostura bitters",
    "maraschino cherry"
  ],
  "bruce's puce": [
    "grenadine",
    "kahlua",
    "baileys irish cream"
  ],
  "bruised heart": [
    "vodka",
    "chambord raspberry liqueur",
    "peachtree schnapps",
    "cranberry juice"
  ],
  "bubble gum": [
    "vodka",
    "banana liqueur",
    "orange juice",
    "peach schnapps"
  ],
  "buccaneer": [
    "corona",
    "bacardi limon"
  ],
  "bumble bee": [
    "baileys irish cream",
    "kahlua",
    "sambuca"
  ],
  "butter baby": [
    "vanilla ice-cream",
    "butterscotch schnapps",
    "milk",
    "vodka"
  ],
  "butterfly effect": [
    "raspberry vodka",
    "cranberry juice",
    "lemonade",
    "blue curacao",
    "sugar syrup",
    "lime juice",
    "mint"
  ],
  "cafe savoy": [
    "coffee",
    "milk",
    "triple sec",
    "brandy"
  ],
  "caipirinha": [
    "sugar",
    "lime",
    "cachaca"
  ],
  "caipirissima": [
    "lime",
    "sugar",
    "white rum",
    "ice"
  ],
  "california lemonade": [
    "blended whiskey",
    "lemon",
    "lime",
    "powdered sugar",
    "grenadine",
    "carbonated water"
  ],
  "california root beer": [
    "kahlua",
    "galliano",
    "soda water"
  ],
  "campari beer": [
    "lager",
    "campari"
  ],
  "captain kidd's punch": [
    "rum",
    "lime juice",
    "egg white",
    "bitters",
    "sugar",
    "nutmeg"
  ],
  "caribbean boilermaker": [
    "corona",
    "light rum"
  ],
  "caribbean orange liqueur": [
    "orange",
    "vodka",
    "sugar"
  ],
  "casa blanca": [
    "light rum",
    "triple sec",
    "lime juice",
    "maraschino liqueur"
  ],
  "casino royale": [
    "gin",
    "lemon juice",
    "maraschino liqueur",
    "orange bitters",
    "egg yolk"
  ],
  "casino": [
    "gin",
    "maraschino liqueur",
    "lemon juice",
    "orange bitters",
    "cherry"
  ],
  "castillian hot chocolate": [
    "cocoa powder",
    "sugar",
    "cornstarch",
    "water",
    "milk"
  ],
  "champagne cocktail": [
    "champagne",
    "sugar",
    "bitters",
    "lemon peel",
    "cognac"
  ],
  "cherry electric lemonade": [
    "gin",
    "tequila",
    "vodka",
    "white rum",
    "triple sec",
    "cherry grenadine",
    "sweet and sour",
    "club soda"
  ],
  "cherry rum": [
    "light rum",
    "cherry brandy",
    "light cream"
  ],
  "chicago fizz": [
    "light rum",
    "port",
    "lemon",
    "powdered sugar",
    "egg white",
    "carbonated water"
  ],
  "chocolate beverage": [
    "milk",
    "chocolate",
    "cinnamon",
    "egg"
  ],
  "chocolate black russian": [
    "kahlua",
    "vodka",
    "chocolate ice-cream"
  ],
  "chocolate drink": [
    "chocolate",
    "milk",
    "water"
  ],
  "chocolate milk": [
    "chocolate liqueur",
    "milk",
    "amaretto"
  ],
  "chocolate monkey": [
    "banana liqueur",
    "creme de cacao",
    "chocolate ice-cream",
    "chocolate syrup",
    "chocolate milk",
    "whipped cream",
    "cherry",
    "banana"
  ],
  "citrus coke": [
    "bacardi limon",
    "coca-cola"
  ],
  "city slicker": [
    "brandy",
    "triple sec",
    "lemon juice"
  ],
  "classic old-fashioned": [
    "bitters",
    "water",
    "sugar",
    "bourbon",
    "orange",
    "maraschino cherry"
  ],
  "clove cocktail": [
    "sweet vermouth",
    "sloe gin",
    "wine"
  ],
  "clover club": [
    "gin",
    "grenadine",
    "lemon",
    "egg white"
  ],
  "cocktail horse’s neck": [
    "cognac",
    "ginger beer",
    "angostura bitters",
    "lemon peel"
  ],
  "coffee liqueur": [
    "coffee",
    "vanilla extract",
    "sugar",
    "vodka",
    "water"
  ],
  "coffee-vodka": [
    "water",
    "sugar",
    "coffee",
    "vanilla",
    "vodka",
    "caramel coloring"
  ],
  "coke and drops": [
    "coca-cola",
    "lemon juice"
  ],
  "corn n oil": [
    "lime",
    "falernum",
    "angostura bitters",
    "añejo rum",
    "blackstrap rum"
  ],
  "corpse reviver": [
    "gin",
    "triple sec",
    "lillet blanc",
    "lemon juice",
    "absinthe"
  ],
  "cosmopolitan martini": [
    "cointreau",
    "vodka",
    "lime",
    "cranberry juice"
  ],
  "cosmopolitan": [
    "absolut citron",
    "lime juice",
    "cointreau",
    "cranberry juice"
  ],
  "cranberry cordial": [
    "cranberries",
    "sugar",
    "light rum"
  ],
  "cranberry punch": [
    "cranberry juice",
    "sugar",
    "pineapple juice",
    "almond flavoring",
    "ginger ale"
  ],
  "cream soda": [
    "spiced rum",
    "ginger ale"
  ],
  "creme de menthe": [
    "sugar",
    "water",
    "grain alcohol",
    "peppermint extract",
    "food coloring"
  ],
  "cuba libra": [
    "dark rum",
    "lime",
    "coca-cola",
    "ice"
  ],
  "cuba libre": [
    "light rum",
    "lime",
    "coca-cola"
  ],
  "daiquiri": [
    "light rum",
    "lime",
    "powdered sugar"
  ],
  "damned if you do": [
    "whiskey",
    "hot damn"
  ],
  "danbooka": [
    "coffee",
    "everclear"
  ],
  "dark and stormy": [
    "dark rum",
    "ginger beer"
  ],
  "dark caipirinha": [
    "demerara sugar",
    "lime",
    "cachaca"
  ],
  "darkwood sling": [
    "cherry heering",
    "soda water",
    "orange juice",
    "ice"
  ],
  "death in the afternoon": [
    "absinthe",
    "champagne"
  ],
  "derby": [
    "gin",
    "peach bitters",
    "mint"
  ],
  "diesel": [
    "lager",
    "cider",
    "blackcurrant cordial"
  ],
  "dirty martini": [
    "vodka",
    "dry vermouth",
    "olive brine",
    "lemon",
    "olive"
  ],
  "dirty nipple": [
    "kahlua",
    "sambuca",
    "baileys irish cream"
  ],
  "downshift": [
    "fruit punch",
    "sprite",
    "tequila",
    "151 proof rum"
  ],
  "dragonfly": [
    "gin",
    "ginger ale",
    "lime"
  ],
  "drinking chocolate": [
    "heavy cream",
    "milk",
    "cinnamon",
    "vanilla",
    "chocolate",
    "whipped cream"
  ],
  "dry martini": [
    "gin",
    "dry vermouth",
    "olive"
  ],
  "dry rob roy": [
    "scotch",
    "dry vermouth",
    "lemon peel"
  ],
  "dubonnet cocktail": [
    "dubonnet rouge",
    "gin",
    "bitters",
    "lemon peel"
  ],
  "duchamp's punch": [
    "pisco",
    "lime juice",
    "pineapple syrup",
    "st. germain",
    "angostura bitters",
    "pepper",
    "lavender"
  ],
  "egg cream": [
    "chocolate syrup",
    "milk",
    "soda water"
  ],
  "egg nog #4": [
    "egg yolk",
    "sugar",
    "milk",
    "light rum",
    "bourbon",
    "vanilla extract",
    "salt",
    "whipping cream",
    "egg white",
    "sugar",
    "nutmeg"
  ],
  "egg nog - healthy": [
    "egg",
    "sugar",
    "condensed milk",
    "milk",
    "vanilla extract",
    "rum",
    "nutmeg"
  ],
  "egg-nog - classic cooked": [
    "egg",
    "sugar",
    "salt",
    "milk",
    "vanilla extract"
  ],
  "elderflower caipirinha": [
    "cachaca",
    "lime",
    "elderflower cordial"
  ],
  "empellón cocina's fat-washed mezcal": [
    "mezcal",
    "chocolate liqueur",
    "coffee liqueur"
  ],
  "english highball": [
    "brandy",
    "gin",
    "sweet vermouth",
    "carbonated water",
    "lemon peel"
  ],
  "english rose cocktail": [
    "apricot brandy",
    "gin",
    "dry vermouth",
    "grenadine",
    "lemon juice",
    "cherry"
  ],
  "espresso martini": [
    "vodka",
    "kahlua",
    "sugar syrup"
  ],
  "espresso rumtini": [
    "rum",
    "vanilla syrup",
    "espresso",
    "coffee"
  ],
  "fahrenheit 5000": [
    "firewater",
    "absolut peppar",
    "tabasco sauce"
  ],
  "figgy thyme": [
    "vodka",
    "honey",
    "figs",
    "thyme",
    "angostura bitters",
    "tonic water"
  ],
  "flaming dr. pepper": [
    "amaretto",
    "vodka",
    "151 proof rum",
    "dr. pepper",
    "beer"
  ],
  "flaming lamborghini": [
    "kahlua",
    "sambuca",
    "blue curacao",
    "baileys irish cream"
  ],
  "flander's flake-out": [
    "sambuca",
    "sarsaparilla"
  ],
  "flying dutchman": [
    "gin",
    "triple sec"
  ],
  "flying scotchman": [
    "scotch",
    "sweet vermouth",
    "bitters",
    "sugar syrup"
  ],
  "foxy lady": [
    "amaretto",
    "creme de cacao",
    "light cream"
  ],
  "frappé": [
    "coffee",
    "milk",
    "sugar"
  ],
  "freddy kruger": [
    "jägermeister",
    "sambuca",
    "vodka"
  ],
  "french 75": [
    "gin",
    "sugar",
    "lemon juice",
    "champagne",
    "orange",
    "maraschino cherry"
  ],
  "french connection": [
    "cognac",
    "amaretto"
  ],
  "french martini": [
    "vodka",
    "raspberry liqueur",
    "pineapple juice"
  ],
  "french negroni": [
    "gin",
    "lillet",
    "sweet vermouth",
    "orange peel"
  ],
  "frisco sour": [
    "blended whiskey",
    "benedictine",
    "lemon",
    "lime",
    "lemon",
    "lime"
  ],
  "frosé": [
    "rose",
    "sugar",
    "strawberries",
    "lemon juice"
  ],
  "frozen daiquiri": [
    "light rum",
    "triple sec",
    "lime juice",
    "sugar",
    "cherry",
    "ice"
  ],
  "frozen mint daiquiri": [
    "light rum",
    "lime juice",
    "mint",
    "sugar"
  ],
  "frozen pineapple daiquiri": [
    "light rum",
    "pineapple",
    "lime juice",
    "sugar"
  ],
  "fruit cooler": [
    "apple juice",
    "strawberries",
    "sugar",
    "lemon",
    "apple",
    "soda water",
    "ice"
  ],
  "fruit flip-flop": [
    "yoghurt",
    "fruit juice"
  ],
  "fruit shake": [
    "yoghurt",
    "banana",
    "orange juice",
    "fruit",
    "ice"
  ],
  "funk and soul": [
    "rum",
    "apricot nectar",
    "pomegranate juice",
    "lemon",
    "soda water"
  ],
  "fuzzy asshole": [
    "coffee",
    "peach schnapps"
  ],
  "gagliardo": [
    "peach vodka",
    "lemon juice",
    "galliano",
    "sirup of roses"
  ],
  "garibaldi negroni": [
    "gin",
    "campari",
    "orange juice",
    "orange peel"
  ],
  "gentleman's club": [
    "gin",
    "brandy",
    "sweet vermouth",
    "club soda"
  ],
  "gg": [
    "galliano",
    "ginger ale",
    "ice"
  ],
  "gideon's green dinosaur": [
    "dark rum",
    "vodka",
    "triple sec",
    "tequila",
    "melon liqueur",
    "mountain dew"
  ],
  "gimlet": [
    "gin",
    "lime juice",
    "sugar syrup",
    "lime"
  ],
  "gin and soda": [
    "gin",
    "soda water",
    "lime"
  ],
  "gin and tonic": [
    "gin",
    "tonic water",
    "lime"
  ],
  "gin basil smash": [
    "gin",
    "lemon juice",
    "sugar syrup",
    "basil"
  ],
  "gin cooler": [
    "gin",
    "carbonated water",
    "powdered sugar",
    "orange spiral",
    "lemon peel"
  ],
  "gin daisy": [
    "gin",
    "lemon juice",
    "sugar",
    "grenadine",
    "maraschino cherry",
    "orange"
  ],
  "gin fizz": [
    "gin",
    "lemon",
    "powdered sugar",
    "carbonated water"
  ],
  "gin lemon": [
    "gin",
    "lemon juice",
    "lemon peel",
    "ice"
  ],
  "gin rickey": [
    "gin",
    "grenadine",
    "lemon",
    "soda water",
    "lime"
  ],
  "gin sling": [
    "gin",
    "lemon",
    "powdered sugar",
    "water",
    "orange peel"
  ],
  "gin smash": [
    "gin",
    "carbonated water",
    "sugar",
    "mint",
    "orange",
    "cherry"
  ],
  "gin sour": [
    "gin",
    "lemon juice",
    "sugar",
    "orange",
    "maraschino cherry"
  ],
  "gin squirt": [
    "gin",
    "grenadine",
    "powdered sugar",
    "pineapple",
    "strawberries",
    "carbonated water"
  ],
  "gin swizzle": [
    "lime juice",
    "sugar",
    "gin",
    "bitters",
    "club soda"
  ],
  "gin toddy": [
    "gin",
    "water",
    "powdered sugar",
    "lemon peel"
  ],
  "gin tonic": [
    "gin",
    "tonic water",
    "lemon peel",
    "ice"
  ],
  "girl from ipanema": [
    "cachaca",
    "lemon juice",
    "agave syrup",
    "champagne"
  ],
  "gluehwein": [
    "red wine",
    "water",
    "sugar",
    "cinnamon",
    "cloves",
    "lemon peel"
  ],
  "godchild": [
    "vodka",
    "amaretto",
    "heavy cream"
  ],
  "godfather": [
    "scotch",
    "amaretto"
  ],
  "godmother": [
    "vodka",
    "amaretto"
  ],
  "golden dream": [
    "galliano",
    "triple sec",
    "orange juice",
    "cream"
  ],
  "grand blue": [
    "malibu rum",
    "peach schnapps",
    "blue curacao",
    "sweet and sour"
  ],
  "grape lemon pineapple smoothie": [
    "grapes",
    "lemon",
    "pineapple"
  ],
  "grass skirt": [
    "gin",
    "triple sec",
    "pineapple juice",
    "grenadine",
    "pineapple"
  ],
  "grasshopper": [
    "green creme de menthe",
    "creme de cacao",
    "light cream"
  ],
  "green goblin": [
    "cider",
    "lager",
    "blue curacao"
  ],
  "greyhound": [
    "vodka",
    "grapefruit juice"
  ],
  "grim reaper": [
    "kahlua",
    "151 proof rum",
    "grenadine"
  ],
  "grizzly bear": [
    "amaretto",
    "jägermeister",
    "kahlua",
    "milk"
  ],
  "h.d.": [
    "whisky",
    "baileys irish cream",
    "coffee"
  ],
  "halloween punch": [
    "cherry juice",
    "orange peel",
    "red chili flakes",
    "cloves",
    "ginger",
    "vodka"
  ],
  "happy skipper": [
    "spiced rum",
    "ginger ale",
    "lime",
    "ice"
  ],
  "harvey wallbanger": [
    "vodka",
    "galliano",
    "orange juice"
  ],
  "havana cocktail": [
    "light rum",
    "pineapple juice",
    "lemon juice"
  ],
  "hawaiian cocktail": [
    "gin",
    "triple sec",
    "pineapple juice"
  ],
  "hemingway special": [
    "rum",
    "grapefruit juice",
    "maraschino liqueur",
    "lime juice"
  ],
  "herbal flame": [
    "hot damn",
    "tea"
  ],
  "highland fling cocktail": [
    "scotch",
    "sweet vermouth",
    "orange bitters",
    "olive"
  ],
  "holloween punch": [
    "grape juice",
    "carbonated soft drink",
    "sherbet",
    "sherbet"
  ],
  "homemade kahlua": [
    "sugar",
    "corn syrup",
    "coffee",
    "vanilla extract",
    "water",
    "vodka"
  ],
  "honey bee": [
    "white rum",
    "honey",
    "lemon juice"
  ],
  "horse's neck": [
    "lemon peel",
    "brandy",
    "ginger ale",
    "bitters"
  ],
  "hot chocolate to die for": [
    "chocolate",
    "butter",
    "vanilla extract",
    "half-and-half",
    "marshmallows"
  ],
  "hot creamy bush": [
    "irish whiskey",
    "baileys irish cream",
    "coffee"
  ],
  "hot toddy": [
    "whiskey",
    "honey",
    "cinnamon",
    "lemon",
    "cloves"
  ],
  "hunter's moon": [
    "vermouth",
    "maraschino cherry",
    "sugar syrup",
    "lemonade",
    "blackberries"
  ],
  "ice pick": [
    "vodka",
    "iced tea",
    "lemon juice"
  ],
  "iced coffee fillip": [
    "kahlua",
    "coffee"
  ],
  "iced coffee": [
    "coffee",
    "sugar",
    "water",
    "milk"
  ],
  "imperial cocktail": [
    "lime juice",
    "gin",
    "aperol"
  ],
  "imperial fizz": [
    "light rum",
    "blended whiskey",
    "lemon",
    "powdered sugar",
    "carbonated water"
  ],
  "ipamena": [
    "lime",
    "brown sugar",
    "passion fruit juice",
    "ginger ale",
    "ice"
  ],
  "irish coffee": [
    "irish whiskey",
    "coffee",
    "sugar",
    "whipped cream"
  ],
  "irish cream": [
    "scotch",
    "half-and-half",
    "condensed milk",
    "coconut syrup",
    "chocolate syrup"
  ],
  "irish curdling cow": [
    "baileys irish cream",
    "bourbon",
    "vodka",
    "orange juice"
  ],
  "irish russian": [
    "vodka",
    "kahlua",
    "coca-cola",
    "guinness stout"
  ],
  "irish spring": [
    "irish whiskey",
    "peach brandy",
    "orange juice",
    "sweet and sour",
    "orange",
    "cherry"
  ],
  "jack rose cocktail": [
    "apple brandy",
    "grenadine",
    "lime"
  ],
  "jack's vanilla coke": [
    "ice",
    "tennessee whiskey",
    "vanilla extract",
    "coca-cola"
  ],
  "jackhammer": [
    "jack daniels",
    "amaretto"
  ],
  "jam donut": [
    "baileys irish cream",
    "chambord raspberry liqueur",
    "sugar syrup",
    "sugar"
  ],
  "jamaica kiss": [
    "coffee liqueur",
    "light rum",
    "ice",
    "milk"
  ],
  "jamaican coffee": [
    "rum",
    "coffee",
    "water",
    "whipped cream"
  ],
  "japanese fizz": [
    "blended whiskey",
    "lemon",
    "powdered sugar",
    "port",
    "egg white",
    "carbonated water"
  ],
  "jello shots": [
    "vodka",
    "jello",
    "water"
  ],
  "jelly bean": [
    "blackberry brandy",
    "anis"
  ],
  "jewel of the nile": [
    "gin",
    "green chartreuse",
    "yellow chartreuse"
  ],
  "jitterbug": [
    "gin",
    "vodka",
    "grenadine",
    "lime juice",
    "sugar",
    "sugar syrup",
    "soda water"
  ],
  "john collins": [
    "bourbon",
    "lemon juice",
    "sugar",
    "club soda",
    "maraschino cherry",
    "orange"
  ],
  "just a moonmint": [
    "milk",
    "chocolate syrup",
    "mint syrup"
  ],
  "kamikaze": [
    "vodka",
    "triple sec",
    "lime juice"
  ],
  "karsk": [
    "coffee",
    "grain alcohol"
  ],
  "kentucky b and b": [
    "bourbon",
    "benedictine"
  ],
  "kentucky colonel": [
    "bourbon",
    "benedictine",
    "lemon peel"
  ],
  "kill the cold smoothie": [
    "ginger",
    "lemon",
    "water"
  ],
  "kioki coffee": [
    "kahlua",
    "brandy",
    "coffee"
  ],
  "kir royale": [
    "creme de cassis",
    "champagne"
  ],
  "kir": [
    "creme de cassis",
    "champagne"
  ],
  "kiss me quick": [
    "cranberry vodka",
    "apfelkorn",
    "schweppes russchian",
    "apple juice",
    "ice"
  ],
  "kiwi lemon": [
    "kiwi liqueur",
    "bitter lemon",
    "ice"
  ],
  "kiwi martini": [
    "kiwi",
    "sugar syrup",
    "vodka",
    "kiwi"
  ],
  "kiwi papaya smoothie": [
    "kiwi",
    "papaya"
  ],
  "kool first aid": [
    "151 proof rum",
    "kool-aid"
  ],
  "kool-aid shot": [
    "vodka",
    "amaretto",
    "sloe gin",
    "triple sec",
    "cranberry juice"
  ],
  "kool-aid slammer": [
    "kool-aid",
    "vodka"
  ],
  "kurant tea": [
    "absolut kurant",
    "tea",
    "sugar"
  ],
  "lady love fizz": [
    "gin",
    "light cream",
    "powdered sugar",
    "lemon",
    "egg white",
    "carbonated water"
  ],
  "lassi - a south indian drink": [
    "yoghurt",
    "water",
    "cumin seed",
    "salt",
    "mint"
  ],
  "lassi - mango": [
    "mango",
    "yoghurt",
    "sugar",
    "water"
  ],
  "lassi - sweet": [
    "yoghurt",
    "water",
    "sugar",
    "salt",
    "lemon juice"
  ],
  "lassi khara": [
    "yoghurt",
    "water",
    "salt",
    "asafoetida"
  ],
  "lassi raita": [
    "yoghurt",
    "ice",
    "sugar",
    "lime",
    "salt"
  ],
  "lazy coconut paloma": [
    "coconut liqueur",
    "grapefruit juice",
    "soda water"
  ],
  "lemon drop": [
    "absolut vodka",
    "cointreau",
    "lemon"
  ],
  "lemon elderflower spritzer": [
    "elderflower cordial",
    "vodka",
    "soda water",
    "fresh lemon juice"
  ],
  "lemon shot": [
    "galliano",
    "absolut citron",
    "lemon",
    "sugar",
    "151 proof rum"
  ],
  "lemouroudji": [
    "ginger",
    "water",
    "lemon",
    "sugar",
    "cayenne pepper"
  ],
  "limeade": [
    "lime",
    "sugar",
    "soda water",
    "lime peel"
  ],
  "limona corona": [
    "corona",
    "bacardi limon"
  ],
  "loch lomond": [
    "scotch",
    "drambuie",
    "dry vermouth",
    "lemon peel"
  ],
  "london town": [
    "gin",
    "maraschino liqueur",
    "orange bitters"
  ],
  "lone tree cocktail": [
    "sweet vermouth",
    "gin"
  ],
  "lone tree cooler": [
    "carbonated water",
    "gin",
    "dry vermouth",
    "powdered sugar",
    "orange spiral",
    "lemon peel"
  ],
  "long island iced tea": [
    "vodka",
    "tequila",
    "light rum",
    "gin",
    "coca-cola",
    "lemon peel"
  ],
  "long island tea": [
    "vodka",
    "light rum",
    "gin",
    "tequila",
    "lemon",
    "coca-cola"
  ],
  "long vodka": [
    "vodka",
    "lime",
    "angostura bitters",
    "tonic water",
    "ice"
  ],
  "lord and lady": [
    "dark rum",
    "tia maria"
  ],
  "lunch box": [
    "beer",
    "amaretto",
    "orange juice"
  ],
  "mai tai": [
    "light rum",
    "orgeat syrup",
    "triple sec",
    "sweet and sour",
    "cherry"
  ],
  "malibu twister": [
    "malibu rum",
    "tropicana",
    "cranberry juice"
  ],
  "mango mojito": [
    "lime",
    "mango",
    "mint",
    "white rum",
    "ice",
    "soda water",
    "mango"
  ],
  "mango orange smoothie": [
    "mango",
    "orange"
  ],
  "manhattan": [
    "sweet vermouth",
    "bourbon",
    "angostura bitters",
    "ice",
    "maraschino cherry",
    "orange peel"
  ],
  "margarita": [
    "tequila",
    "triple sec",
    "lime juice",
    "salt"
  ],
  "martinez 2": [
    "gin",
    "sweet vermouth",
    "maraschino liqueur",
    "angostura bitters"
  ],
  "martinez cocktail": [
    "gin",
    "dry vermouth",
    "triple sec",
    "orange bitters",
    "cherry"
  ],
  "martini": [
    "gin",
    "dry vermouth",
    "olive"
  ],
  "mary pickford": [
    "light rum",
    "pineapple juice",
    "maraschino liqueur",
    "grenadine",
    "maraschino cherry"
  ],
  "masala chai": [
    "water",
    "tea",
    "ginger",
    "cardamom",
    "cloves",
    "cinnamon",
    "black pepper",
    "sugar",
    "milk"
  ],
  "melya": [
    "espresso",
    "honey",
    "cocoa powder"
  ],
  "miami vice": [
    "151 proof rum",
    "pina colada mix",
    "daiquiri mix"
  ],
  "michelada": [
    "beer",
    "tomato juice",
    "lime juice",
    "hot sauce",
    "worcestershire sauce",
    "soy sauce"
  ],
  "microwave hot cocoa": [
    "sugar",
    "cocoa powder",
    "salt",
    "water",
    "milk",
    "vanilla extract"
  ],
  "midnight cowboy": [
    "bourbon",
    "dark rum",
    "heavy cream"
  ],
  "midnight manx": [
    "kahlua",
    "baileys irish cream",
    "goldschlager",
    "heavy cream",
    "coffee"
  ],
  "midnight mint": [
    "baileys irish cream",
    "white creme de menthe",
    "cream"
  ],
  "mimosa": [
    "champagne",
    "orange juice"
  ],
  "mint julep": [
    "mint",
    "bourbon",
    "powdered sugar",
    "water"
  ],
  "mississippi planters punch": [
    "brandy",
    "light rum",
    "bourbon",
    "lemon",
    "powdered sugar",
    "carbonated water"
  ],
  "mocha-berry": [
    "coffee",
    "chambord raspberry liqueur",
    "cocoa powder",
    "whipped cream"
  ],
  "mojito extra": [
    "mint",
    "lemon juice",
    "dark rum",
    "club soda",
    "angostura bitters"
  ],
  "mojito": [
    "light rum",
    "lime",
    "sugar",
    "mint",
    "soda water"
  ],
  "monkey gland": [
    "gin",
    "benedictine",
    "orange juice",
    "grenadine"
  ],
  "monkey wrench": [
    "light rum",
    "grapefruit juice",
    "bitters"
  ],
  "moranguito": [
    "absinthe",
    "tequila",
    "grenadine"
  ],
  "moscow mule": [
    "vodka",
    "lime juice",
    "ginger ale"
  ],
  "mother's milk": [
    "goldschlager",
    "butterscotch schnapps",
    "milk"
  ],
  "mountain bramble": [
    "gin",
    "lemon juice",
    "sugar syrup",
    "blackberries",
    "soda water",
    "mint"
  ],
  "mudslinger": [
    "southern comfort",
    "orange juice",
    "pepsi cola"
  ],
  "mulled wine": [
    "water",
    "sugar",
    "cloves",
    "cinnamon",
    "lemon peel",
    "red wine",
    "brandy"
  ],
  "munich mule": [
    "gin",
    "lime juice",
    "ginger beer",
    "cucumber",
    "lemon"
  ],
  "national aquarium": [
    "rum",
    "vodka",
    "gin",
    "blue curacao",
    "sour mix",
    "lemon-lime soda"
  ],
  "negroni": [
    "gin",
    "campari",
    "sweet vermouth"
  ],
  "new york lemonade": [
    "absolut citron",
    "grand marnier",
    "lemon juice",
    "club soda"
  ],
  "new york sour": [
    "blended whiskey",
    "lemon",
    "sugar",
    "red wine",
    "lemon",
    "cherry"
  ],
  "nuked hot chocolate": [
    "cocoa powder",
    "sugar",
    "vanilla extract",
    "milk"
  ],
  "nutty irishman": [
    "baileys irish cream",
    "frangelico",
    "milk"
  ],
  "oatmeal cookie": [
    "kahlua",
    "baileys irish cream",
    "butterscotch schnapps",
    "jagermeister",
    "goldschlager"
  ],
  "old fashioned": [
    "bourbon",
    "angostura bitters",
    "sugar",
    "water"
  ],
  "old pal": [
    "rye whiskey",
    "campari",
    "dry vermouth"
  ],
  "orange crush": [
    "vodka",
    "triple sec",
    "orange juice"
  ],
  "orange oasis": [
    "cherry brandy",
    "gin",
    "orange juice",
    "ginger ale"
  ],
  "orange push-up": [
    "spiced rum",
    "grenadine",
    "orange juice",
    "sour mix"
  ],
  "orange rosemary collins": [
    "gin",
    "orange juice",
    "lemon juice",
    "rosemary syrup",
    "soda water",
    "rosemary",
    "orange peel"
  ],
  "orange scented hot chocolate": [
    "milk",
    "chocolate",
    "orange peel",
    "espresso",
    "nutmeg"
  ],
  "orange whip": [
    "orange juice",
    "rum",
    "vodka",
    "cream",
    "ice"
  ],
  "orangeade": [
    "lemon juice",
    "orange juice",
    "sugar syrup",
    "soda water"
  ],
  "oreo mudslide": [
    "vodka",
    "kahlua",
    "baileys irish cream",
    "vanilla ice-cream",
    "oreo cookie"
  ],
  "orgasm": [
    "creme de cacao",
    "amaretto",
    "triple sec",
    "vodka",
    "light cream"
  ],
  "owen's grandmother's revenge": [
    "whiskey",
    "beer",
    "lemonade",
    "ice"
  ],
  "paloma": [
    "grape soda",
    "tequila"
  ],
  "paradise": [
    "gin",
    "apricot brandy",
    "orange juice"
  ],
  "passion fruit martini": [
    "vodka",
    "sugar syrup",
    "passion fruit juice"
  ],
  "pegu club": [
    "gin",
    "orange curacao",
    "lime juice",
    "angostura bitters",
    "orange bitters"
  ],
  "penicillin": [
    "blended scotch",
    "lemon juice",
    "honey syrup",
    "ginger syrup",
    "islay single malt scotch"
  ],
  "pina colada": [
    "light rum",
    "coconut milk",
    "pineapple"
  ],
  "pineapple gingerale smoothie": [
    "ginger",
    "pineapple"
  ],
  "pineapple paloma": [
    "tequila",
    "grapefruit juice",
    "fresh lime juice",
    "pineapple juice",
    "lime",
    "pepper"
  ],
  "pink gin": [
    "bitters",
    "gin"
  ],
  "pink lady": [
    "gin",
    "grenadine",
    "light cream",
    "egg white"
  ],
  "pink moon": [
    "gin",
    "coconut liqueur",
    "elderflower cordial",
    "lime juice",
    "blackberries"
  ],
  "pink panty pulldowns": [
    "sprite",
    "pink lemonade",
    "vodka"
  ],
  "pink penocha": [
    "everclear",
    "vodka",
    "peach schnapps",
    "orange juice",
    "cranberry juice"
  ],
  "pisco sour": [
    "pisco",
    "lemon juice",
    "sugar",
    "ice",
    "egg white"
  ],
  "planter's punch": [
    "dark rum",
    "orgeat syrup",
    "orange juice",
    "pineapple juice"
  ],
  "planter’s punch": [
    "dark rum",
    "orange juice",
    "pineapple juice",
    "grenadine",
    "sugar syrup",
    "angostura bitters"
  ],
  "popped cherry": [
    "vodka",
    "cherry liqueur",
    "cranberry juice",
    "orange juice"
  ],
  "poppy cocktail": [
    "gin",
    "creme de cacao"
  ],
  "pornstar martini": [
    "vodka",
    "passoa",
    "passion fruit juice",
    "lime",
    "prosecco"
  ],
  "port and starboard": [
    "grenadine",
    "green creme de menthe"
  ],
  "port wine cocktail": [
    "port",
    "brandy"
  ],
  "port wine flip": [
    "port",
    "light cream",
    "powdered sugar",
    "egg",
    "nutmeg"
  ],
  "porto flip": [
    "brandy",
    "port",
    "egg yolk"
  ],
  "pure passion": [
    "rum",
    "passoa",
    "lime juice",
    "passion fruit syrup",
    "peach bitters",
    "mint"
  ],
  "pysch vitamin light": [
    "orange juice",
    "apple juice",
    "pineapple juice",
    "ice"
  ],
  "quaker's cocktail": [
    "light rum",
    "brandy",
    "lemon",
    "raspberry syrup"
  ],
  "quarter deck cocktail": [
    "light rum",
    "sherry",
    "lime"
  ],
  "queen bee": [
    "coffee brandy",
    "lime vodka",
    "sherry"
  ],
  "queen charlotte": [
    "red wine",
    "grenadine",
    "lemon-lime soda"
  ],
  "queen elizabeth": [
    "dry vermouth",
    "gin",
    "benedictine"
  ],
  "quentin": [
    "dark rum",
    "kahlua",
    "light cream",
    "nutmeg"
  ],
  "quick f**k": [
    "kahlua",
    "midori melon liqueur",
    "baileys irish cream"
  ],
  "quick-sand": [
    "black sambuca",
    "orange juice"
  ],
  "radioactive long island iced tea": [
    "rum",
    "vodka",
    "tequila",
    "gin",
    "triple sec",
    "chambord raspberry liqueur",
    "midori melon liqueur",
    "malibu rum"
  ],
  "radler": [
    "beer",
    "7-up"
  ],
  "rail splitter": [
    "sugar syrup",
    "lemon juice",
    "ginger ale"
  ],
  "ramos gin fizz": [
    "gin",
    "lemon juice",
    "sugar syrup",
    "cream",
    "egg white",
    "vanilla extract",
    "soda water"
  ],
  "raspberry cooler": [
    "raspberry vodka",
    "lemon-lime soda",
    "ice"
  ],
  "raspberry julep": [
    "bourbon",
    "raspberry syrup",
    "mint"
  ],
  "red snapper": [
    "crown royal",
    "amaretto",
    "cranberry juice"
  ],
  "rose": [
    "dry vermouth",
    "gin",
    "apricot brandy",
    "lemon juice",
    "grenadine",
    "powdered sugar"
  ],
  "rosemary blue": [
    "gin",
    "blue curacao",
    "tonic water",
    "rosemary"
  ],
  "royal bitch": [
    "frangelico",
    "crown royal"
  ],
  "royal fizz": [
    "gin",
    "sweet and sour",
    "egg",
    "coca-cola"
  ],
  "royal flush": [
    "crown royal",
    "peach schnapps",
    "chambord raspberry liqueur",
    "cranberry juice"
  ],
  "royal gin fizz": [
    "gin",
    "lemon",
    "powdered sugar",
    "egg",
    "carbonated water"
  ],
  "ruby tuesday": [
    "gin",
    "cranberry juice",
    "grenadine"
  ],
  "rum cobbler": [
    "sugar",
    "club soda",
    "lemon",
    "dark rum",
    "maraschino cherry",
    "orange"
  ],
  "rum cooler": [
    "rum",
    "lemon-lime soda",
    "lemon"
  ],
  "rum milk punch": [
    "light rum",
    "milk",
    "powdered sugar",
    "nutmeg"
  ],
  "rum old-fashioned": [
    "light rum",
    "151 proof rum",
    "powdered sugar",
    "bitters",
    "water",
    "lime peel"
  ],
  "rum punch": [
    "rum",
    "ginger ale",
    "fruit punch",
    "orange juice",
    "ice"
  ],
  "rum runner": [
    "malibu rum",
    "blackberry brandy",
    "orange juice",
    "pineapple juice",
    "cranberry juice"
  ],
  "rum screwdriver": [
    "light rum",
    "orange juice"
  ],
  "rum sour": [
    "light rum",
    "lemon juice",
    "sugar",
    "orange",
    "maraschino cherry"
  ],
  "rum toddy": [
    "rum",
    "powdered sugar",
    "lemon peel",
    "water"
  ],
  "russian spring punch": [
    "vodka",
    "creme de cassis",
    "sugar syrup",
    "lemon juice"
  ],
  "rusty nail": [
    "scotch",
    "drambuie",
    "lemon peel"
  ],
  "salted toffee martini": [
    "gin",
    "chocolate liqueur",
    "amaretto",
    "chocolate sauce",
    "salted chocolate"
  ],
  "salty dog": [
    "grapefruit juice",
    "gin",
    "salt"
  ],
  "san francisco": [
    "vodka",
    "creme de banane",
    "grenadine",
    "orange juice"
  ],
  "sangria": [
    "red wine",
    "sugar",
    "orange juice",
    "lemon juice",
    "cloves",
    "cinnamon"
  ],
  "sazerac": [
    "ricard",
    "sugar",
    "peychaud bitters",
    "water",
    "bourbon",
    "lemon peel"
  ],
  "scooter": [
    "brandy",
    "amaretto",
    "light cream"
  ],
  "scotch cobbler": [
    "scotch",
    "brandy",
    "curacao",
    "orange",
    "mint"
  ],
  "scotch sour": [
    "scotch",
    "lime",
    "powdered sugar",
    "lemon",
    "cherry"
  ],
  "scottish highland liqueur": [
    "johnnie walker",
    "honey",
    "angelica root",
    "fennel seeds",
    "lemon peel"
  ],
  "screaming orgasm": [
    "vodka",
    "baileys irish cream",
    "kahlua"
  ],
  "screwdriver": [
    "vodka",
    "orange juice"
  ],
  "sea breeze": [
    "vodka",
    "cranberry juice",
    "grapefruit juice"
  ],
  "sex on the beach": [
    "vodka",
    "peach schnapps",
    "cranberry juice",
    "grapefruit juice"
  ],
  "shanghai cocktail": [
    "light rum",
    "anisette",
    "grenadine",
    "lemon"
  ],
  "shark attack": [
    "lemonade",
    "water",
    "vodka"
  ],
  "sherry eggnog": [
    "sherry",
    "powdered sugar",
    "egg",
    "milk",
    "nutmeg"
  ],
  "sherry flip": [
    "sherry",
    "light cream",
    "powdered sugar",
    "egg",
    "nutmeg"
  ],
  "shot-gun": [
    "jim beam",
    "jack daniels",
    "wild turkey"
  ],
  "sidecar cocktail": [
    "brandy",
    "triple sec",
    "lemon"
  ],
  "sidecar": [
    "cognac",
    "cointreau",
    "lemon juice"
  ],
  "singapore sling": [
    "cherry brandy",
    "grenadine",
    "gin",
    "sweet and sour",
    "carbonated water",
    "cherry"
  ],
  "slippery nipple": [
    "sambuca",
    "irish cream"
  ],
  "sloe gin cocktail": [
    "sloe gin",
    "dry vermouth",
    "orange bitters"
  ],
  "smashed watermelon margarita": [
    "watermelon",
    "mint",
    "grapefruit juice",
    "lime",
    "tequila",
    "watermelon",
    "mint"
  ],
  "smut": [
    "red wine",
    "peach schnapps",
    "pepsi cola",
    "orange juice"
  ],
  "snake bite (uk)": [
    "lager",
    "cider"
  ],
  "snakebite and black": [
    "lager",
    "cider",
    "blackcurrant squash"
  ],
  "snowball": [
    "advocaat",
    "lemonade",
    "lemon",
    "ice"
  ],
  "snowday": [
    "vodka",
    "amaro montenegro",
    "ruby port",
    "blood orange",
    "angostura bitters",
    "orange peel"
  ],
  "sol y sombra": [
    "brandy",
    "anisette"
  ],
  "space odyssey": [
    "151 proof rum",
    "malibu rum",
    "pineapple juice",
    "orange juice",
    "grenadine",
    "cherries"
  ],
  "spanish chocolate": [
    "milk",
    "chocolate",
    "cinnamon",
    "egg yolk"
  ],
  "spice 75": [
    "sugar",
    "allspice",
    "rum",
    "lime juice",
    "champagne",
    "orange spiral"
  ],
  "spiced peach punch": [
    "peach nectar",
    "orange juice",
    "brown sugar",
    "cinnamon",
    "cloves",
    "lime juice"
  ],
  "spiking coffee": [
    "coffee",
    "cinnamon"
  ],
  "spritz veneziano": [
    "prosecco",
    "aperol",
    "soda water"
  ],
  "spritz": [
    "prosecco",
    "campari",
    "soda water"
  ],
  "stinger": [
    "brandy",
    "white creme de menthe"
  ],
  "stone sour": [
    "apricot brandy",
    "orange juice",
    "sweet and sour"
  ],
  "strawberry daiquiri": [
    "strawberry schnapps",
    "light rum",
    "lime juice",
    "powdered sugar",
    "strawberries"
  ],
  "strawberry lemonade": [
    "lemon",
    "sugar",
    "strawberries",
    "water"
  ],
  "strawberry margarita": [
    "strawberry schnapps",
    "tequila",
    "triple sec",
    "lemon juice",
    "strawberries",
    "salt"
  ],
  "strawberry shivers": [
    "strawberries",
    "honey",
    "water"
  ],
  "sunny holiday punch": [
    "pineapple juice",
    "club soda",
    "orange juice",
    "lemon",
    "berries",
    "champagne"
  ],
  "surf city lifesaver": [
    "ouzo",
    "baileys irish cream",
    "gin",
    "grand marnier"
  ],
  "swedish coffee": [
    "coffee",
    "aquavit",
    "sugar"
  ],
  "sweet bananas": [
    "milk",
    "banana",
    "honey"
  ],
  "sweet sangria": [
    "red wine",
    "sugar",
    "water",
    "apple",
    "orange",
    "lime",
    "lemon",
    "fresca"
  ],
  "sweet tooth": [
    "godiva liqueur",
    "milk"
  ],
  "talos coffee": [
    "grand marnier",
    "coffee"
  ],
  "tennesee mud": [
    "coffee",
    "jack daniels",
    "amaretto",
    "whipped cream"
  ],
  "tequila fizz": [
    "tequila",
    "lemon juice",
    "grenadine",
    "egg white",
    "ginger ale"
  ],
  "tequila slammer": [
    "tequila",
    "7-up"
  ],
  "tequila sour": [
    "tequila",
    "lemon",
    "powdered sugar",
    "lemon",
    "cherry"
  ],
  "tequila sunrise": [
    "tequila",
    "orange juice",
    "grenadine"
  ],
  "tequila surprise": [
    "tequila",
    "tabasco sauce"
  ],
  "texas rattlesnake": [
    "yukon jack",
    "cherry brandy",
    "southern comfort",
    "sweet and sour"
  ],
  "texas sling": [
    "kahlua",
    "irish cream",
    "amaretto",
    "151 proof rum",
    "cream"
  ],
  "thai coffee": [
    "coffee",
    "coriander",
    "cardamom",
    "sugar",
    "whipping cream",
    "ice"
  ],
  "thai iced coffee": [
    "coffee",
    "sugar",
    "cream",
    "cardamom"
  ],
  "thai iced tea": [
    "tea",
    "water",
    "condensed milk",
    "ice",
    "mint"
  ],
  "the evil blue thing": [
    "creme de cacao",
    "blue curacao",
    "light rum"
  ],
  "the galah": [
    "dark rum",
    "campari",
    "creme de banane",
    "pineapple juice",
    "lime juice"
  ],
  "the jimmy conway": [
    "irish whiskey",
    "amaretto",
    "cranberry juice"
  ],
  "the last word": [
    "green chartreuse",
    "maraschino liqueur",
    "lime juice"
  ],
  "the laverstoke": [
    "gin",
    "elderflower cordial",
    "rosso vermouth",
    "tonic water",
    "lime",
    "ginger",
    "mint"
  ],
  "the philosopher": [
    "gin",
    "melon liqueur",
    "orange bitters",
    "lemon juice",
    "prosecco"
  ],
  "the strange weaver": [
    "light rum",
    "gin",
    "sweet vermouth",
    "campari",
    "lemon juice",
    "orgeat syrup",
    "orange peel"
  ],
  "thriller": [
    "scotch",
    "wine",
    "orange juice"
  ],
  "tia-maria": [
    "water",
    "brown sugar",
    "coffee",
    "rum",
    "vanilla extract"
  ],
  "tipperary": [
    "irish whiskey",
    "sweet vermouth",
    "green chartreuse"
  ],
  "tom collins": [
    "gin",
    "lemon juice",
    "sugar",
    "club soda",
    "maraschino cherry",
    "orange"
  ],
  "tomato tang": [
    "tomato juice",
    "lemon juice",
    "celery salt"
  ],
  "tommy's margarita": [
    "tequila",
    "lime juice",
    "agave syrup"
  ],
  "turf cocktail": [
    "dry vermouth",
    "gin",
    "anis",
    "bitters",
    "orange peel"
  ],
  "turkeyball": [
    "wild turkey",
    "amaretto",
    "pineapple juice"
  ],
  "tuxedo cocktail": [
    "dry vermouth",
    "gin",
    "maraschino liqueur",
    "anis",
    "orange bitters",
    "cherry"
  ],
  "valencia cocktail": [
    "apricot brandy",
    "orange juice",
    "orange bitters"
  ],
  "vampiro": [
    "tequila",
    "tomato juice",
    "orange juice",
    "lime juice",
    "sugar syrup",
    "salt"
  ],
  "van vleet": [
    "light rum",
    "maple syrup",
    "lemon juice"
  ],
  "vermouth cassis": [
    "dry vermouth",
    "creme de cassis",
    "carbonated water"
  ],
  "vesper": [
    "gin",
    "vodka",
    "lillet blanc"
  ],
  "vesuvio": [
    "light rum",
    "sweet vermouth",
    "lemon",
    "powdered sugar",
    "egg white"
  ],
  "veteran": [
    "dark rum",
    "cherry brandy"
  ],
  "victor": [
    "gin",
    "sweet vermouth",
    "brandy"
  ],
  "victory collins": [
    "vodka",
    "lemon juice",
    "grape juice",
    "powdered sugar",
    "orange"
  ],
  "vodka and tonic": [
    "vodka",
    "tonic water"
  ],
  "vodka fizz": [
    "vodka",
    "half-and-half",
    "limeade",
    "ice",
    "nutmeg"
  ],
  "vodka lemon": [
    "vodka",
    "lemon juice",
    "lemon peel",
    "ice"
  ],
  "vodka martini": [
    "vodka",
    "dry vermouth",
    "olive"
  ],
  "vodka russian": [
    "vodka",
    "schweppes russchian"
  ],
  "vodka slime": [
    "sprite",
    "lime juice",
    "vodka"
  ],
  "vodka tonic": [
    "vodka",
    "tonic water",
    "lemon peel"
  ],
  "waikiki beachcomber": [
    "triple sec",
    "gin",
    "pineapple juice"
  ],
  "whiskey sour": [
    "blended whiskey",
    "lemon",
    "powdered sugar",
    "cherry",
    "lemon"
  ],
  "whisky mac": [
    "scotch",
    "wine"
  ],
  "white lady": [
    "gin",
    "triple sec",
    "lemon juice"
  ],
  "white russian": [
    "vodka",
    "coffee liqueur",
    "light cream"
  ],
  "white wine sangria": [
    "lime",
    "lemon",
    "white wine",
    "strawberries",
    "apple",
    "apple brandy",
    "soda water"
  ],
  "whitecap margarita": [
    "ice",
    "tequila",
    "cream of coconut",
    "lime juice"
  ],
  "wine cooler": [
    "red wine",
    "lemon-lime soda",
    "ice"
  ],
  "wine punch": [
    "red wine",
    "lemon",
    "orange juice",
    "orange",
    "pineapple juice"
  ],
  "winter paloma": [
    "tequila",
    "grapefruit juice",
    "lime juice",
    "agave syrup",
    "pepper"
  ],
  "winter rita": [
    "tequila",
    "campari",
    "lime juice",
    "orange juice",
    "rosemary syrup",
    "salt"
  ],
  "yellow bird": [
    "white rum",
    "galliano",
    "triple sec",
    "lime juice"
  ],
  "yoghurt cooler": [
    "yoghurt",
    "fruit",
    "ice"
  ],
  "zambeer": [
    "sambuca",
    "root beer",
    "ice"
  ],
  "zenmeister": [
    "jägermeister",
    "root beer"
  ],
  "ziemes martini apfelsaft": [
    "vermouth",
    "apple juice"
  ],
  "zima blaster": [
    "zima",
    "chambord raspberry liqueur"
  ],
  "zimadori zinger": [
    "midori melon liqueur",
    "zima"
  ],
  "zinger": [
    "peachtree schnapps",
    "surge"
  ],
  "zipperhead": [
    "chambord raspberry liqueur",
    "vodka",
    "soda water"
  ],
  "zippy's revenge": [
    "amaretto",
    "rum",
    "kool-aid"
  ],
  "zizi coin-coin": [
    "cointreau",
    "lemon juice",
    "ice",
    "lemon"
  ],
  "zoksel": [
    "beer",
    "root beer",
    "lemonade",
    "coca-cola",
    "7-up",
    "creme de cassis",
    "lemon"
  ],
  "zombie": [
    "rum",
    "gold rum",
    "151 proof rum",
    "pernod",
    "grenadine",
    "lime juice",
    "angostura bitters"
  ],
  "zorbatini": [
    "vodka",
    "ouzo"
  ],
  "zorro": [
    "sambuca",
    "baileys irish cream",
    "white creme de menthe"
  ]
};
var drink_names = ["1-900-fuk-meup", "3 wise men", "3-mile long island iced tea", "9 1/2 weeks", "24k nightmare", "50/50", 
"57 chevy with a white license plate", "69 special", "110 in the shade", "151 florida bushwacker", "155 belmont", "252", 
"410 gone", "501 blue", "747 drink", "747", "a1", "a day at the beach", "a furlong too late", "a gilligan's island",
"a midsummernight dream", "a night in old mandalay", "a piece of ass", "a splash of nash", "a true amaretto sour",
"a. j.", "a.d.m. (after dinner mint)", "abbey cocktail", "abbey martini", "abc", "abilene", "absinthe #2",
"absolut evergreen", "absolut limousine", "absolut sex", "absolut stress #2", "absolut summertime", 
"absolutely cranberry smash", "absolutely fabulous", "absolutly screwed up", "acapulco", "ace", "acid", "adam & eve",
"adam bomb", "adam sunrise", "adam", "addington", "addison special", "addison", "adios amigos cocktail", "adonis cocktail",
"affair", "affinity", "after dinner cocktail", "after five", "after sex", "after supper cocktail", "afterglow",
"afternoon", "alabama slammer", "alaska cocktail", "alexander", "alfie cocktail", "algonquin", "alice cocktail",
"alice in wonderland", "allegheny", "allies cocktail", "almeria", "almond chocolate coffee", "almond joy",
"aloha fruit punch", "amaretto and cream", "amaretto fizz", "amaretto liqueur", "amaretto mist", "amaretto rose", 
"amaretto shake", "amaretto sour", "amaretto stinger", "amaretto stone sour alternative", "amaretto stone sour", 
"amaretto sunrise", "amaretto sunset", "amaretto sweet & sour", "amaretto tea", "americano", "angel face", "angelica liqueur",
 "apello", "aperol spritz", "apple berry smoothie", "apple cider punch", "apple grande", "apple highball", "apple karate", 
 "apple pie with a crust", "apple slammer", "applecar", "applejack", "apricot lady", "apricot punch", "aquamarine", 
 "archbishop", "arctic fish", "arctic mouthwash", "arise my love", "arizona antifreeze", "arizona stingers", "arizona twister",
  "army special", "arthur tompkins", "artillery punch", "artillery", "at&t", "atlantic sun", "atomic lokade",
   "auburn headbanger", "autodafé", "autumn garibaldi", "avalanche", "avalon", "aviation", "aztec punch", "b-52", "b-53", 
   "baby eskimo", "baby guinness", "bacardi cocktail", "bahama mama", "bailey's dream shake", "balmoral", 
   "banana cantaloupe smoothie", "banana cream pi", "banana daiquiri", "banana milk shake", "banana strawberry shake daiquiri", 
   "banana strawberry shake", "barracuda", "bee's knees", "belgian blue", "bellini martini", "bellini", "bermuda highball", 
   "berry deadly", "between the sheets", "bible belt", "big red", "bijou", "black & tan", "black and brown", 
   "black forest shake", "black russian", "blackthorn", "bleeding surgeon", "blind russian", "bloody maria", "bloody mary", 
   "bloody punch", "blue hurricane", "blue lagoon", "blue margarita", "blue mountain", "blueberry mojito", "bluebird",
    "bob marley", "bobby burns cocktail", "bombay cassis", "boomerang", "boozy snickers milkshake", "bora bora", 
    "boston sidecar", "boston sour", "boulevardier", "bounty hunter", "bourbon sling", "bourbon sour", "boxcar", 
    "brain fart", "brainteaser", "bramble", "brandon and will's coke float", "brandy alexander", "brandy cobbler", 
    "brandy flip", "brandy sour", "brave bull shooter", "brigadier", "broadside", "brooklyn", "bruce's puce", 
    "bruised heart", "bubble gum", "buccaneer", "bumble bee", "butter baby", "butterfly effect", "cafe savoy", 
    "caipirinha", "caipirissima", "california lemonade", "california root beer", "campari beer", "captain kidd's punch", 
    "caribbean boilermaker", "caribbean orange liqueur", "casa blanca", "casino royale", "casino", 
    "castillian hot chocolate", "champagne cocktail", "cherry electric lemonade", "cherry rum", "chicago fizz",
     "chocolate beverage", "chocolate black russian", "chocolate drink", "chocolate milk", "chocolate monkey", 
     "citrus coke", "city slicker", "classic old-fashioned", "clove cocktail", "clover club", "cocktail horse’s neck", 
     "coffee liqueur", "coffee-vodka", "coke and drops", "corn n oil", "corpse reviver", "cosmopolitan martini", 
     "cosmopolitan", "cranberry cordial", "cranberry punch", "cream soda", "creme de menthe", "cuba libra", "cuba libre",
      "daiquiri", "damned if you do", "danbooka", "dark and stormy", "dark caipirinha", "darkwood sling", 
      "death in the afternoon", "derby", "diesel", "dirty martini", "dirty nipple", "downshift", "dragonfly", 
      "drinking chocolate", "dry martini", "dry rob roy", "dubonnet cocktail", "duchamp's punch", "egg cream", 
      "egg nog #4", "egg nog - healthy", "egg-nog - classic cooked", "elderflower caipirinha",
       "empellón cocina's fat-washed mezcal", "english highball", "english rose cocktail", "espresso martini", 
       "espresso rumtini", "fahrenheit 5000", "figgy thyme", "flaming dr. pepper", "flaming lamborghini",
        "flander's flake-out", "flying dutchman", "flying scotchman", "foxy lady", "frappé", "freddy kruger",
         "french 75", "french connection", "french martini", "french negroni", "frisco sour", "frosé", "frozen daiquiri", 
         "frozen mint daiquiri", "frozen pineapple daiquiri", "fruit cooler", "fruit flip-flop", "fruit shake", "funk and soul", "fuzzy asshole", "gagliardo", "garibaldi negroni", "gentleman's club", "gg", "gideon's green dinosaur", "gimlet", "gin and soda", "gin and tonic", "gin basil smash", "gin cooler", "gin daisy", "gin fizz", "gin lemon", "gin rickey", "gin sling", "gin smash", "gin sour", "gin squirt", "gin swizzle", "gin toddy", "gin tonic", "girl from ipanema", "gluehwein", "godchild", "godfather", "godmother", "golden dream", "grand blue", "grape lemon pineapple smoothie", "grass skirt", "grasshopper", "green goblin", "greyhound", "grim reaper", "grizzly bear", "h.d.", "halloween punch", "happy skipper", "harvey wallbanger", "havana cocktail", "hawaiian cocktail", "hemingway special", "herbal flame", "highland fling cocktail", "holloween punch", "homemade kahlua", "honey bee", "horse's neck", "hot chocolate to die for", "hot creamy bush", "hot toddy", "hunter's moon", "ice pick", "iced coffee fillip", "iced coffee", "imperial cocktail", "imperial fizz", "ipamena", "irish coffee", "irish cream", "irish curdling cow", "irish russian", "irish spring", "jack rose cocktail", "jack's vanilla coke", "jackhammer", "jam donut", "jamaica kiss", "jamaican coffee", "japanese fizz", "jello shots", "jelly bean", "jewel of the nile", "jitterbug", "john collins", "just a moonmint", "kamikaze", "karsk", "kentucky b and b", "kentucky colonel", "kill the cold smoothie", "kioki coffee", "kir royale", "kir", "kiss me quick", "kiwi lemon", "kiwi martini", "kiwi papaya smoothie", "kool first aid", "kool-aid shot", "kool-aid slammer", "kurant tea", "lady love fizz", "lassi - a south indian drink", "lassi - mango", "lassi - sweet", "lassi khara", "lassi raita", "lazy coconut paloma", "lemon drop", "lemon elderflower spritzer", "lemon shot", "lemouroudji", "limeade", "limona corona", "loch lomond", "london town", "lone tree cocktail", "lone tree cooler", "long island iced tea", "long island tea", "long vodka", "lord and lady", "lunch box", "mai tai", "malibu twister", "mango mojito", "mango orange smoothie", "manhattan", "margarita", "martinez 2", "martinez cocktail", "martini", "mary pickford", "masala chai", "melya", "miami vice", "michelada", "microwave hot cocoa", "midnight cowboy", "midnight manx", "midnight mint", "mimosa", "mint julep", "mississippi planters punch", "mocha-berry", "mojito extra", "mojito", "monkey gland", "monkey wrench", "moranguito", "moscow mule", "mother's milk", "mountain bramble", "mudslinger", "mulled wine", "munich mule", "national aquarium", "negroni", "new york lemonade", "new york sour", "nuked hot chocolate", "nutty irishman", "oatmeal cookie", "old fashioned", "old pal", "orange crush", "orange oasis", "orange push-up", "orange rosemary collins", "orange scented hot chocolate", "orange whip", "orangeade", "oreo mudslide", "orgasm", "owen's grandmother's revenge", "paloma", "paradise", "passion fruit martini", "pegu club", "penicillin", "pina colada", "pineapple gingerale smoothie", "pineapple paloma", "pink gin", "pink lady", "pink moon", "pink panty pulldowns", "pink penocha", "pisco sour", "planter's punch", "planter’s punch", "popped cherry", "poppy cocktail", "pornstar martini", "port and starboard", "port wine cocktail", "port wine flip", "porto flip", "pure passion", "pysch vitamin light", "quaker's cocktail", "quarter deck cocktail", "queen bee", "queen charlotte", "queen elizabeth", "quentin", "quick f**k", "quick-sand", "radioactive long island iced tea", "radler", "rail splitter", "ramos gin fizz", "raspberry cooler", "raspberry julep", "red snapper", "rose", "rosemary blue", "royal bitch", "royal fizz", "royal flush", "royal gin fizz", "ruby tuesday", "rum cobbler", "rum cooler", "rum milk punch", "rum old-fashioned", "rum punch", "rum runner", "rum screwdriver", "rum sour", "rum toddy", "russian spring punch", "rusty nail", "salted toffee martini", "salty dog", "san francisco", "sangria", "sazerac", "scooter", "scotch cobbler", "scotch sour", "scottish highland liqueur", "screaming orgasm", "screwdriver", "sea breeze", "sex on the beach", "shanghai cocktail", "shark attack", "sherry eggnog", "sherry flip", "shot-gun", "sidecar cocktail", "sidecar", "singapore sling", "slippery nipple", "sloe gin cocktail", "smashed watermelon margarita", "smut", "snake bite (uk)", "snakebite and black", "snowball", "snowday", "sol y sombra", "space odyssey", "spanish chocolate", "spice 75", "spiced peach punch", "spiking coffee", "spritz veneziano", "spritz", "stinger", "stone sour", "strawberry daiquiri", "strawberry lemonade", "strawberry margarita", "strawberry shivers", "sunny holiday punch", "surf city lifesaver", "swedish coffee", "sweet bananas", "sweet sangria", "sweet tooth", "talos coffee", "tennesee mud", "tequila fizz", "tequila slammer", "tequila sour", "tequila sunrise", "tequila surprise", "texas rattlesnake", "texas sling", "thai coffee", "thai iced coffee", "thai iced tea", "the evil blue thing", "the galah", "the jimmy conway", "the last word", "the laverstoke", "the philosopher", "the strange weaver", "thriller", "tia-maria", "tipperary", "tom collins", "tomato tang", "tommy's margarita", "turf cocktail", "turkeyball", "tuxedo cocktail", "valencia cocktail", "vampiro", "van vleet", "vermouth cassis", "vesper", "vesuvio", "veteran", "victor", "victory collins", "vodka and tonic", "vodka fizz", "vodka lemon", "vodka martini", "vodka russian", "vodka slime", "vodka tonic", 
     "waikiki beachcomber", "whiskey sour", "whisky mac", "white lady", "white russian", "white wine sangria", 
    "whitecap margarita", "wine cooler", "wine punch", "winter paloma", "winter rita", "yellow bird", 
    "yoghurt cooler", "zambeer", "zenmeister", "ziemes martini apfelsaft", "zima blaster", "zimadori zinger", 
    "zinger", "zipperhead", "zippy's revenge", "zizi coin-coin", "zoksel", "zombie", "zorbatini", "zorro"];

var ingredients = {
    "vodka": [
      "155 belmont",
      "501 blue",
      "57 chevy with a white license plate",
      "747 drink",
      "a gilligan's island",
      "a midsummernight dream",
      "a.d.m. (after dinner mint)",
      "absinthe #2",
      "absolutely fabulous",
      "adam bomb",
      "adam sunrise",
      "addison special",
      "after sex",
      "apricot punch",
      "arctic fish",
      "arizona antifreeze",
      "arizona twister",
      "army special",
      "atlantic sun",
      "atomic lokade",
      "autodafé",
      "avalon",
      "aztec punch",
      "belgian blue",
      "bellini martini",
      "black russian",
      "bloody mary",
      "bloody punch",
      "blue lagoon",
      "blue mountain",
      "brain fart",
      "bruised heart",
      "bubble gum",
      "caribbean orange liqueur",
      "cherry electric lemonade",
      "chocolate black russian",
      "cosmopolitan martini",
      "dirty martini",
      "espresso martini",
      "figgy thyme",
      "flaming dr. pepper",
      "freddy kruger",
      "french martini",
      "gideon's green dinosaur",
      "godchild",
      "godmother",
      "greyhound",
      "harvey wallbanger",
      "ice pick",
      "irish curdling cow",
      "irish russian",
      "jello shots",
      "jitterbug",
      "kamikaze",
      "kiwi martini",
      "kool-aid shot",
      "kool-aid slammer",
      "lemon elderflower spritzer",
      "long island iced tea",
      "long island tea",
      "long vodka",
      "moscow mule",
      "national aquarium",
      "orange crush",
      "orange whip",
      "oreo mudslide",
      "passion fruit martini",
      "pink panty pulldowns",
      "pink penocha",
      "popped cherry",
      "pornstar martini",
      "radioactive long island iced tea",
      "russian spring punch",
      "san francisco",
      "screaming orgasm",
      "screwdriver",
      "sea breeze",
      "sex on the beach",
      "shark attack",
      "snowday",
      "vesper",
      "victory collins",
      "vodka and tonic",
      "vodka fizz",
      "vodka lemon",
      "vodka martini",
      "vodka russian",
      "vodka slime",
      "vodka tonic",
      "white russian",
      "zipperhead",
      "zorbatini"
    ],
    "gin": [
      "3-mile long island iced tea",
      "69 special",
      "a1",
      "abbey cocktail",
      "abbey martini",
      "ace",
      "adam & eve",
      "addison",
      "alaska cocktail",
      "alexander",
      "allies cocktail",
      "angel face",
      "archbishop",
      "army special",
      "arthur tompkins",
      "artillery",
      "at&t",
      "aviation",
      "bermuda highball",
      "bijou",
      "bluebird",
      "bombay cassis",
      "boomerang",
      "boxcar",
      "bramble",
      "casino",
      "casino royale",
      "cherry electric lemonade",
      "clover club",
      "corpse reviver",
      "derby",
      "dragonfly",
      "dry martini",
      "dubonnet cocktail",
      "english highball",
      "english rose cocktail",
      "flying dutchman",
      "french 75",
      "french negroni",
      "garibaldi negroni",
      "gentleman's club",
      "gimlet",
      "gin and soda",
      "gin and tonic",
      "gin basil smash",
      "gin cooler",
      "gin daisy",
      "gin fizz",
      "gin lemon",
      "gin rickey",
      "gin sling",
      "gin smash",
      "gin sour",
      "gin squirt",
      "gin swizzle",
      "gin toddy",
      "gin tonic",
      "grass skirt",
      "hawaiian cocktail",
      "imperial cocktail",
      "jewel of the nile",
      "jitterbug",
      "lady love fizz",
      "london town",
      "lone tree cocktail",
      "lone tree cooler",
      "long island tea",
      "martinez 2",
      "martinez cocktail",
      "martini",
      "monkey gland",
      "mountain bramble",
      "munich mule",
      "national aquarium",
      "negroni",
      "orange oasis",
      "orange rosemary collins",
      "paradise",
      "pegu club",
      "pink gin",
      "pink lady",
      "pink moon",
      "poppy cocktail",
      "queen elizabeth",
      "ramos gin fizz",
      "rose",
      "rosemary blue",
      "royal fizz",
      "royal gin fizz",
      "ruby tuesday",
      "salted toffee martini",
      "salty dog",
      "singapore sling",
      "surf city lifesaver",
      "the laverstoke",
      "the philosopher",
      "the strange weaver",
      "tom collins",
      "turf cocktail",
      "tuxedo cocktail"
    ],
    "rum": [
      "adam bomb",
      "adios amigos cocktail",
      "aztec punch",
      "bahama mama",
      "barracuda",
      "blue hurricane",
      "bounty hunter",
      "captain kidd's punch",
      "espresso rumtini",
      "funk and soul",
      "hemingway special",
      "jamaican coffee",
      "national aquarium",
      "orange whip",
      "pure passion",
      "radioactive long island iced tea",
      "rum cooler",
      "rum punch",
      "rum toddy",
      "spice 75",
      "zippy's revenge",
      "zombie"
    ],
    "tequila": [
      "110 in the shade",
      "3-mile long island iced tea",
      "adam bomb",
      "amaretto stone sour alternative",
      "apple grande",
      "bloody maria",
      "blue margarita",
      "brave bull shooter",
      "cherry electric lemonade",
      "downshift",
      "long island iced tea",
      "margarita",
      "moranguito",
      "paloma",
      "pineapple paloma",
      "radioactive long island iced tea",
      "strawberry margarita",
      "tequila fizz",
      "tequila slammer",
      "tequila sour",
      "tequila sunrise",
      "tequila surprise",
      "tommy's margarita",
      "vampiro",
      "whitecap margarita",
      "winter paloma",
      "winter rita"
    ],
    "scotch": [
      "affinity",
      "balmoral",
      "bobby burns cocktail",
      "broadside",
      "dry rob roy",
      "flying scotchman",
      "godfather",
      "highland fling cocktail",
      "irish cream",
      "loch lomond",
      "rusty nail",
      "scotch cobbler",
      "scotch sour",
      "thriller",
      "whisky mac"
    ],
    "absolut kurant": [
      "1-900-fuk-meup",
      "absolut sex",
      "kurant tea"
    ],
    "absolut peppar": [
      "fahrenheit 5000"
    ],
    "absolut vodka": [
      "absolut stress #2",
      "absolutely cranberry smash",
      "arizona stingers",
      "at&t",
      "lemon drop"
    ],
    "advocaat": [
      "brainteaser",
      "snowball"
    ],
    "agave syrup": [
      "girl from ipanema",
      "tommy's margarita"
    ],
    "ale": [
      "black & tan"
    ],
    "allspice": [
      "angelica liqueur",
      "spice 75"
    ],
    "almond": [
      "angelica liqueur"
    ],
    "amaretto": [
      "a day at the beach",
      "a piece of ass",
      "a true amaretto sour",
      "abc",
      "alabama slammer",
      "alice in wonderland",
      "almond chocolate coffee",
      "almond joy",
      "amaretto and cream",
      "amaretto fizz",
      "amaretto mist",
      "amaretto rose",
      "amaretto shake",
      "amaretto sour",
      "amaretto stinger",
      "amaretto stone sour",
      "amaretto stone sour alternative",
      "amaretto sunrise",
      "amaretto sunset",
      "amaretto sweet & sour",
      "amaretto tea",
      "chocolate milk",
      "flaming dr. pepper",
      "foxy lady",
      "french connection",
      "godchild",
      "godfather",
      "godmother",
      "grizzly bear",
      "jackhammer",
      "kool-aid shot",
      "lunch box",
      "orgasm",
      "red snapper",
      "salted toffee martini",
      "scooter",
      "tennesee mud",
      "texas sling",
      "the jimmy conway",
      "turkeyball",
      "zippy's revenge"
    ],
    "angelica root": [
      "angelica liqueur",
      "scottish highland liqueur"
    ],
    "angostura bitters": [
      "cocktail horse’s neck",
      "corn n oil",
      "long vodka",
      "manhattan",
      "old fashioned"
    ],
    "anis": [
      "jelly bean",
      "turf cocktail"
    ],
    "anise": [
      "absinthe #2"
    ],
    "anisette": [
      "shanghai cocktail",
      "sol y sombra"
    ],
    "aperol": [
      "aperol spritz",
      "imperial cocktail",
      "spritz veneziano"
    ],
    "apfelkorn": [
      "kiss me quick"
    ],
    "apple brandy": [
      "angel face",
      "jack rose cocktail"
    ],
    "apple cider": [
      "apple cider punch",
      "apple grande"
    ],
    "apple juice": [
      "apello",
      "apple karate",
      "apple pie with a crust",
      "avalon",
      "banana strawberry shake daiquiri",
      "fruit cooler",
      "pysch vitamin light",
      "ziemes martini apfelsaft"
    ],
    "apple schnapps": [
      "apple highball",
      "apple slammer"
    ],
    "apple": [
      "apple berry smoothie"
    ],
    "applejack": [
      "a. j.",
      "applecar"
    ],
    "apricot brandy": [
      "after dinner cocktail",
      "after supper cocktail",
      "angel face",
      "apricot lady",
      "apricot punch",
      "english rose cocktail",
      "paradise",
      "rose",
      "stone sour",
      "valencia cocktail"
    ],
    "apricot nectar": [
      "funk and soul"
    ],
    "apricot": [
      "amaretto liqueur"
    ],
    "aquavit": [
      "swedish coffee"
    ],
    "añejo rum": [
      "a night in old mandalay",
      "blue mountain"
    ],
    "bacardi limon": [
      "buccaneer",
      "citrus coke",
      "limona corona"
    ],
    "baileys irish cream": [
      "747",
      "abc",
      "after five",
      "afternoon",
      "b-52",
      "baby guinness",
      "bailey's dream shake",
      "blind russian",
      "bruce's puce",
      "bumble bee",
      "dirty nipple",
      "h.d.",
      "hot creamy bush",
      "irish curdling cow",
      "jam donut",
      "midnight manx",
      "midnight mint",
      "nutty irishman",
      "oatmeal cookie",
      "oreo mudslide",
      "quick f**k",
      "screaming orgasm",
      "surf city lifesaver",
      "zorro"
    ],
    "banana liqueur": [
      "aquamarine",
      "bahama mama",
      "banana cream pi",
      "bubble gum",
      "chocolate monkey"
    ],
    "banana": [
      "banana cantaloupe smoothie",
      "banana daiquiri",
      "banana strawberry shake",
      "banana strawberry shake daiquiri",
      "fruit shake",
      "sweet bananas"
    ],
    "beer": [
      "lunch box",
      "michelada",
      "owen's grandmother's revenge",
      "radler",
      "zoksel"
    ],
    "benedictine": [
      "archbishop",
      "bobby burns cocktail",
      "frisco sour",
      "kentucky b and b",
      "kentucky colonel",
      "monkey gland",
      "queen elizabeth"
    ],
    "berries": [
      "apple berry smoothie"
    ],
    "bitter lemon": [
      "kiwi lemon"
    ],
    "bitters": [
      "artillery",
      "boomerang",
      "broadside",
      "champagne cocktail",
      "classic old-fashioned",
      "dubonnet cocktail",
      "flying scotchman",
      "monkey wrench",
      "pink gin"
    ],
    "black sambuca": [
      "quick-sand"
    ],
    "blackberry brandy": [
      "allegheny",
      "jelly bean",
      "rum runner"
    ],
    "blackcurrant cordial": [
      "diesel"
    ],
    "blackcurrant squash": [
      "snakebite and black"
    ],
    "blended whiskey": [
      "algonquin",
      "boston sour",
      "california lemonade",
      "frisco sour",
      "imperial fizz",
      "japanese fizz",
      "new york sour",
      "whiskey sour"
    ],
    "blue curacao": [
      "501 blue",
      "atomic lokade",
      "belgian blue",
      "blue lagoon",
      "blue margarita",
      "bluebird",
      "flaming lamborghini",
      "grand blue",
      "green goblin",
      "rosemary blue",
      "the evil blue thing"
    ],
    "blueberries": [
      "bounty hunter"
    ],
    "blueberry schnapps": [
      "501 blue"
    ],
    "bourbon": [
      "allegheny",
      "bourbon sour",
      "brandon and will's coke float",
      "irish curdling cow",
      "john collins",
      "kentucky b and b",
      "kentucky colonel",
      "manhattan",
      "midnight cowboy",
      "mint julep",
      "mississippi planters punch",
      "old fashioned",
      "raspberry julep"
    ],
    "brandy": [
      "amaretto shake",
      "bermuda highball",
      "between the sheets",
      "boston sidecar",
      "brandy alexander",
      "brandy flip",
      "brandy sour",
      "city slicker",
      "english highball",
      "gentleman's club",
      "horse's neck",
      "kioki coffee",
      "mississippi planters punch",
      "port wine cocktail",
      "porto flip",
      "quaker's cocktail",
      "scooter",
      "scotch cobbler",
      "sidecar cocktail",
      "sol y sombra",
      "stinger",
      "victor"
    ],
    "brown sugar": [
      "apple cider punch",
      "ipamena",
      "spiced peach punch",
      "tia-maria"
    ],
    "butter": [
      "hot chocolate to die for"
    ],
    "butterscotch schnapps": [
      "butter baby",
      "mother's milk",
      "oatmeal cookie"
    ],
    "cachaca": [
      "caipirinha",
      "dark caipirinha",
      "elderflower caipirinha",
      "girl from ipanema"
    ],
    "campari": [
      "americano",
      "autumn garibaldi",
      "boulevardier",
      "campari beer",
      "garibaldi negroni",
      "negroni",
      "old pal",
      "spritz",
      "the galah",
      "winter rita"
    ],
    "cantaloupe": [
      "banana cantaloupe smoothie"
    ],
    "carbonated soft drink": [
      "holloween punch"
    ],
    "carbonated water": [
      "gin cooler",
      "gin smash",
      "lone tree cooler",
      "vermouth cassis"
    ],
    "cardamom": [
      "thai coffee"
    ],
    "celery salt": [
      "tomato tang"
    ],
    "chambord raspberry liqueur": [
      "1-900-fuk-meup",
      "bruised heart",
      "jam donut",
      "mocha-berry",
      "royal flush",
      "zima blaster",
      "zipperhead"
    ],
    "champagne": [
      "absolutely fabulous",
      "apricot punch",
      "arise my love",
      "bellini",
      "champagne cocktail",
      "death in the afternoon",
      "kir",
      "kir royale",
      "mimosa"
    ],
    "cherry brandy": [
      "black forest shake",
      "cherry rum",
      "orange oasis",
      "singapore sling",
      "texas rattlesnake",
      "veteran"
    ],
    "cherry heering": [
      "brigadier",
      "darkwood sling"
    ],
    "cherry juice": [
      "halloween punch"
    ],
    "cherry liqueur": [
      "popped cherry"
    ],
    "chocolate ice-cream": [
      "amaretto shake",
      "chocolate black russian",
      "chocolate monkey"
    ],
    "chocolate liqueur": [
      "chocolate milk",
      "empellón cocina's fat-washed mezcal",
      "salted toffee martini"
    ],
    "chocolate syrup": [
      "black forest shake",
      "egg cream",
      "just a moonmint"
    ],
    "chocolate": [
      "chocolate beverage",
      "chocolate drink",
      "hot chocolate to die for",
      "orange scented hot chocolate",
      "spanish chocolate"
    ],
    "cider": [
      "amaretto sunset",
      "diesel",
      "green goblin",
      "snake bite (uk)",
      "snakebite and black"
    ],
    "cinnamon": [
      "apple pie with a crust",
      "chocolate beverage",
      "drinking chocolate",
      "hot toddy",
      "spanish chocolate",
      "spiking coffee"
    ],
    "cloves": [
      "mulled wine"
    ],
    "club soda": [
      "amaretto rose",
      "brandy cobbler",
      "rum cobbler",
      "sunny holiday punch"
    ],
    "coca-cola": [
      "410 gone",
      "brandon and will's coke float",
      "citrus coke",
      "coke and drops",
      "cuba libra",
      "cuba libre",
      "irish russian"
    ],
    "cocoa powder": [
      "castillian hot chocolate",
      "melya",
      "microwave hot cocoa",
      "mocha-berry",
      "nuked hot chocolate"
    ],
    "coconut liqueur": [
      "absolut stress #2",
      "belgian blue",
      "bounty hunter",
      "lazy coconut paloma",
      "pink moon"
    ],
    "coconut milk": [
      "pina colada"
    ],
    "coconut rum": [
      "a day at the beach"
    ],
    "coffee brandy": [
      "queen bee"
    ],
    "coffee liqueur": [
      "black russian",
      "empellón cocina's fat-washed mezcal",
      "jamaica kiss",
      "white russian"
    ],
    "coffee": [
      "almond chocolate coffee",
      "cafe savoy",
      "coffee liqueur",
      "coffee-vodka",
      "danbooka",
      "frappé",
      "fuzzy asshole",
      "h.d.",
      "homemade kahlua",
      "hot creamy bush",
      "iced coffee",
      "iced coffee fillip",
      "irish coffee",
      "jamaican coffee",
      "karsk",
      "kioki coffee",
      "mocha-berry",
      "spiking coffee",
      "swedish coffee",
      "talos coffee",
      "tennesee mud",
      "thai coffee",
      "thai iced coffee",
      "tia-maria"
    ],
    "cognac": [
      "abc",
      "adam & eve",
      "adios amigos cocktail",
      "apple highball",
      "cocktail horse’s neck",
      "french connection",
      "sidecar"
    ],
    "cointreau": [
      "cosmopolitan",
      "cosmopolitan martini",
      "lemon drop",
      "sidecar",
      "zizi coin-coin"
    ],
    "condensed milk": [
      "egg nog - healthy",
      "irish cream",
      "thai iced tea"
    ],
    "coriander": [
      "thai coffee"
    ],
    "corn syrup": [
      "homemade kahlua"
    ],
    "cornstarch": [
      "castillian hot chocolate"
    ],
    "corona": [
      "buccaneer",
      "caribbean boilermaker",
      "limona corona"
    ],
    "cranberries": [
      "cranberry cordial"
    ],
    "cranberry juice": [
      "747 drink",
      "a splash of nash",
      "absolut sex",
      "absolutely cranberry smash",
      "absolutely fabulous",
      "affair",
      "butterfly effect",
      "cranberry punch",
      "malibu twister",
      "popped cherry",
      "red snapper",
      "ruby tuesday",
      "sea breeze",
      "sex on the beach",
      "the jimmy conway"
    ],
    "cranberry vodka": [
      "kiss me quick"
    ],
    "cream of coconut": [
      "whitecap margarita"
    ],
    "cream": [
      "avalanche",
      "bailey's dream shake",
      "midnight mint",
      "thai iced coffee"
    ],
    "creme de banane": [
      "after sex",
      "san francisco",
      "the galah"
    ],
    "creme de cacao": [
      "57 chevy with a white license plate",
      "alexander",
      "almond joy",
      "brandy alexander",
      "chocolate monkey",
      "foxy lady",
      "grasshopper",
      "orgasm",
      "poppy cocktail",
      "the evil blue thing"
    ],
    "creme de cassis": [
      "adam & eve",
      "bombay cassis",
      "kir",
      "kir royale",
      "russian spring punch",
      "vermouth cassis"
    ],
    "crown royal": [
      "avalanche",
      "red snapper",
      "royal bitch",
      "royal flush"
    ],
    "cumin seed": [
      "lassi - a south indian drink"
    ],
    "curacao": [
      "scotch cobbler"
    ],
    "daiquiri mix": [
      "miami vice"
    ],
    "dark creme de cacao": [
      "almond chocolate coffee"
    ],
    "dark rum": [
      "155 belmont",
      "abilene",
      "adam",
      "almeria",
      "bahama mama",
      "bleeding surgeon",
      "blue hurricane",
      "blueberry mojito",
      "cuba libra",
      "dark and stormy",
      "gideon's green dinosaur",
      "lord and lady",
      "midnight cowboy",
      "mojito extra",
      "planter's punch",
      "planter’s punch",
      "quentin",
      "the galah",
      "veteran"
    ],
    "demerara sugar": [
      "dark caipirinha"
    ],
    "drambuie": [
      "loch lomond",
      "rusty nail"
    ],
    "dry vermouth": [
      "addington",
      "adios amigos cocktail",
      "affinity",
      "algonquin",
      "allegheny",
      "allies cocktail",
      "balmoral",
      "bermuda highball",
      "boomerang",
      "brooklyn",
      "dirty martini",
      "dry martini",
      "dry rob roy",
      "english rose cocktail",
      "loch lomond",
      "lone tree cooler",
      "martinez cocktail",
      "martini",
      "old pal",
      "queen elizabeth",
      "rose",
      "sloe gin cocktail",
      "turf cocktail",
      "tuxedo cocktail",
      "vermouth cassis",
      "vodka martini"
    ],
    "dubonnet rouge": [
      "dubonnet cocktail"
    ],
    "egg white": [
      "almeria",
      "captain kidd's punch"
    ],
    "egg yolk": [
      "egg nog #4",
      "porto flip"
    ],
    "egg": [
      "brandy flip",
      "egg nog - healthy",
      "egg-nog - classic cooked",
      "royal fizz",
      "sherry eggnog"
    ],
    "erin cream": [
      "brainteaser"
    ],
    "espresso": [
      "espresso rumtini",
      "melya"
    ],
    "everclear": [
      "berry deadly",
      "brain fart",
      "danbooka",
      "pink penocha"
    ],
    "firewater": [
      "fahrenheit 5000"
    ],
    "frangelico": [
      "747",
      "afternoon",
      "nutty irishman",
      "royal bitch"
    ],
    "fruit juice": [
      "fruit flip-flop"
    ],
    "fruit punch": [
      "downshift",
      "rum punch"
    ],
    "fruit": [
      "yoghurt cooler"
    ],
    "galliano": [
      "barracuda",
      "california root beer",
      "gagliardo",
      "gg",
      "golden dream",
      "harvey wallbanger",
      "lemon shot",
      "yellow bird"
    ],
    "ginger ale": [
      "absolutely cranberry smash",
      "cream soda",
      "dragonfly",
      "gg",
      "happy skipper",
      "horse's neck",
      "moscow mule",
      "rail splitter",
      "rum punch"
    ],
    "ginger beer": [
      "a furlong too late",
      "autumn garibaldi",
      "cocktail horse’s neck",
      "dark and stormy",
      "munich mule"
    ],
    "ginger": [
      "aloha fruit punch",
      "kill the cold smoothie",
      "lemouroudji",
      "masala chai",
      "pineapple gingerale smoothie"
    ],
    "godiva liqueur": [
      "blind russian",
      "boozy snickers milkshake",
      "sweet tooth"
    ],
    "gold rum": [
      "bee's knees",
      "zombie"
    ],
    "gold tequila": [
      "arizona twister"
    ],
    "goldschlager": [
      "24k nightmare",
      "auburn headbanger",
      "big red",
      "bob marley",
      "midnight manx",
      "mother's milk"
    ],
    "grain alcohol": [
      "creme de menthe",
      "karsk"
    ],
    "grand marnier": [
      "1-900-fuk-meup",
      "50/50",
      "a1",
      "alice in wonderland",
      "arthur tompkins",
      "b-52",
      "b-53",
      "new york lemonade",
      "talos coffee"
    ],
    "grape juice": [
      "holloween punch",
      "victory collins"
    ],
    "grape soda": [
      "arctic fish",
      "paloma"
    ],
    "grapefruit juice": [
      "a. j.",
      "apello",
      "greyhound",
      "hemingway special",
      "lazy coconut paloma",
      "monkey wrench",
      "pineapple paloma",
      "salty dog",
      "sea breeze",
      "smashed watermelon margarita",
      "winter paloma"
    ],
    "grapes": [
      "grape lemon pineapple smoothie"
    ],
    "green chartreuse": [
      "bijou",
      "brigadier",
      "jewel of the nile",
      "the last word",
      "tipperary"
    ],
    "green creme de menthe": [
      "arise my love",
      "grasshopper",
      "port and starboard"
    ],
    "grenadine": [
      "ace",
      "adam",
      "addison special",
      "afterglow",
      "alice cocktail",
      "amaretto sunrise",
      "bruce's puce",
      "clover club",
      "gin rickey",
      "gin squirt",
      "grim reaper",
      "jack rose cocktail",
      "jitterbug",
      "moranguito",
      "orange push-up",
      "pink lady",
      "port and starboard",
      "queen charlotte",
      "ruby tuesday",
      "san francisco",
      "shanghai cocktail",
      "singapore sling",
      "tequila fizz",
      "tequila sunrise"
    ],
    "guava juice": [
      "aloha fruit punch"
    ],
    "guinness stout": [
      "black & tan",
      "black and brown"
    ],
    "half-and-half": [
      "irish cream",
      "vodka fizz"
    ],
    "heavy cream": [
      "ace",
      "drinking chocolate",
      "godchild",
      "midnight cowboy"
    ],
    "honey": [
      "figgy thyme",
      "honey bee",
      "hot toddy",
      "melya",
      "scottish highland liqueur",
      "strawberry shivers",
      "sweet bananas"
    ],
    "hot chocolate": [
      "brigadier"
    ],
    "hot damn": [
      "damned if you do",
      "herbal flame"
    ],
    "hpnotiq": [
      "aquamarine"
    ],
    "ice": [
      "a piece of ass",
      "a true amaretto sour",
      "absolut evergreen",
      "absolut limousine",
      "arctic mouthwash",
      "bellini martini",
      "black forest shake",
      "gg",
      "jack's vanilla coke",
      "jamaica kiss",
      "kiwi lemon",
      "lassi raita",
      "raspberry cooler",
      "whitecap margarita",
      "wine cooler",
      "yoghurt cooler",
      "zambeer",
      "zizi coin-coin"
    ],
    "iced tea": [
      "arizona stingers",
      "ice pick"
    ],
    "irish cream": [
      "big red",
      "slippery nipple",
      "texas sling"
    ],
    "irish whiskey": [
      "hot creamy bush",
      "irish coffee",
      "irish spring",
      "the jimmy conway",
      "tipperary"
    ],
    "jack daniels": [
      "3 wise men",
      "applejack",
      "jackhammer",
      "shot-gun",
      "tennesee mud"
    ],
    "jello": [
      "jello shots"
    ],
    "jagermeister": [
      "24k nightmare",
      "auburn headbanger",
      "bob marley",
      "freddy kruger",
      "grizzly bear",
      "zenmeister"
    ],
    "jim beam": [
      "3 wise men",
      "shot-gun"
    ],
    "johnnie walker": [
      "3 wise men",
      "scottish highland liqueur"
    ],
    "kahlua": [
      "747",
      "after five",
      "afternoon",
      "almeria",
      "avalanche",
      "b-52",
      "b-53",
      "baby eskimo",
      "baby guinness",
      "blind russian",
      "bruce's puce",
      "bumble bee",
      "california root beer",
      "chocolate black russian",
      "dirty nipple",
      "espresso martini",
      "flaming lamborghini",
      "grim reaper",
      "grizzly bear",
      "iced coffee fillip",
      "irish russian",
      "kioki coffee",
      "midnight manx",
      "oatmeal cookie",
      "oreo mudslide",
      "quentin",
      "quick f**k",
      "screaming orgasm",
      "texas sling"
    ],
    "kirschwasser": [
      "a midsummernight dream"
    ],
    "kiwi liqueur": [
      "kiwi lemon"
    ],
    "kiwi": [
      "kiwi martini",
      "kiwi papaya smoothie"
    ],
    "kool-aid": [
      "kool first aid",
      "kool-aid slammer",
      "zippy's revenge"
    ],
    "kummel": [
      "allies cocktail"
    ],
    "lager": [
      "110 in the shade",
      "campari beer",
      "diesel",
      "green goblin",
      "snake bite (uk)",
      "snakebite and black"
    ],
    "lemon juice": [
      "69 special",
      "a1",
      "adam",
      "after supper cocktail",
      "applecar",
      "arthur tompkins",
      "aviation",
      "bloody maria",
      "bloody mary",
      "bora bora",
      "bourbon sling",
      "bourbon sour",
      "boxcar",
      "bramble",
      "casino",
      "casino royale",
      "city slicker",
      "coke and drops",
      "french 75",
      "gagliardo",
      "gin basil smash",
      "gin daisy",
      "gin lemon",
      "gin sour",
      "girl from ipanema",
      "havana cocktail",
      "honey bee",
      "ice pick",
      "john collins",
      "mojito extra",
      "mountain bramble",
      "new york lemonade",
      "orange rosemary collins",
      "orangeade",
      "penicillin",
      "pisco sour",
      "rail splitter",
      "ramos gin fizz",
      "rum sour",
      "sidecar",
      "tequila fizz",
      "tom collins",
      "tomato tang",
      "van vleet",
      "victory collins",
      "vodka lemon",
      "white lady",
      "zizi coin-coin"
    ],
    "lemon peel": [
      "a furlong too late",
      "americano",
      "blackthorn",
      "dry rob roy",
      "gin lemon",
      "gin tonic",
      "horse's neck",
      "kentucky colonel",
      "rum toddy",
      "rusty nail",
      "vodka lemon",
      "vodka tonic"
    ],
    "lemon vodka": [
      "alfie cocktail"
    ],
    "lemon-lime soda": [
      "queen charlotte",
      "raspberry cooler",
      "rum cooler",
      "wine cooler"
    ],
    "lemon": [
      "a true amaretto sour",
      "boston sour",
      "brandy cobbler",
      "brandy sour",
      "california lemonade",
      "chicago fizz",
      "clover club",
      "frisco sour",
      "gin fizz",
      "gin rickey",
      "gin sling",
      "grape lemon pineapple smoothie",
      "imperial fizz",
      "japanese fizz",
      "kill the cold smoothie",
      "lemon drop",
      "lemon shot",
      "lemouroudji",
      "new york sour",
      "quaker's cocktail",
      "royal gin fizz",
      "rum cobbler",
      "rum cooler",
      "sidecar cocktail",
      "snowball",
      "strawberry lemonade",
      "tequila sour",
      "vesuvio",
      "whiskey sour",
      "white wine sangria",
      "wine punch"
    ],
    "lemonade": [
      "adam sunrise",
      "apple cider punch",
      "atomic lokade",
      "aztec punch",
      "blue lagoon",
      "butterfly effect",
      "owen's grandmother's revenge",
      "shark attack",
      "snowball",
      "zoksel"
    ],
    "light cream": [
      "alexander",
      "almond joy",
      "amaretto and cream",
      "brandy alexander",
      "cherry rum",
      "foxy lady",
      "grasshopper",
      "lady love fizz",
      "pink lady",
      "port wine flip",
      "quentin",
      "scooter",
      "sherry flip",
      "white russian"
    ],
    "light rum": [
      "151 florida bushwacker",
      "155 belmont",
      "3-mile long island iced tea",
      "a furlong too late",
      "a night in old mandalay",
      "acapulco",
      "apricot lady",
      "bacardi cocktail",
      "banana daiquiri",
      "between the sheets",
      "boston sidecar",
      "caribbean boilermaker",
      "casa blanca",
      "cherry rum",
      "chicago fizz",
      "cranberry cordial",
      "cuba libre",
      "daiquiri",
      "frozen daiquiri",
      "frozen mint daiquiri",
      "frozen pineapple daiquiri",
      "havana cocktail",
      "imperial fizz",
      "jamaica kiss",
      "long island iced tea",
      "long island tea",
      "mai tai",
      "mary pickford",
      "mississippi planters punch",
      "mojito",
      "monkey wrench",
      "pina colada",
      "quaker's cocktail",
      "quarter deck cocktail",
      "rum milk punch",
      "rum old-fashioned",
      "rum screwdriver",
      "rum sour",
      "shanghai cocktail",
      "strawberry daiquiri",
      "the evil blue thing",
      "the strange weaver",
      "van vleet",
      "vesuvio"
    ],
    "lillet": [
      "french negroni"
    ],
    "lime juice cordial": [
      "army special"
    ],
    "lime juice": [
      "absolut limousine",
      "acapulco",
      "amaretto rose",
      "autodafé",
      "bacardi cocktail",
      "bee's knees",
      "bloody punch",
      "blue margarita",
      "blueberry mojito",
      "captain kidd's punch",
      "casa blanca",
      "cosmopolitan",
      "duchamp's punch",
      "frozen daiquiri",
      "frozen mint daiquiri",
      "frozen pineapple daiquiri",
      "gimlet",
      "gin swizzle",
      "imperial cocktail",
      "kamikaze",
      "margarita",
      "michelada",
      "moscow mule",
      "munich mule",
      "pegu club",
      "pure passion",
      "strawberry daiquiri",
      "the last word",
      "tommy's margarita",
      "vodka slime",
      "winter paloma",
      "winter rita"
    ],
    "lime vodka": [
      "queen bee"
    ],
    "lime": [
      "after dinner cocktail",
      "amaretto mist",
      "apple highball",
      "bible belt",
      "caipirinha",
      "caipirissima",
      "california lemonade",
      "corn n oil",
      "cosmopolitan martini",
      "cuba libra",
      "cuba libre",
      "daiquiri",
      "dark caipirinha",
      "dragonfly",
      "elderflower caipirinha",
      "gin and soda",
      "gin and tonic",
      "happy skipper",
      "ipamena",
      "jack rose cocktail",
      "limeade",
      "long vodka",
      "mango mojito",
      "mojito",
      "quarter deck cocktail",
      "scotch sour",
      "white wine sangria"
    ],
    "limeade": [
      "vodka fizz"
    ],
    "malibu rum": [
      "151 florida bushwacker",
      "apple pie with a crust",
      "arizona twister",
      "banana cream pi",
      "grand blue",
      "malibu twister",
      "rum runner",
      "space odyssey"
    ],
    "mango": [
      "lassi - mango",
      "mango mojito",
      "mango orange smoothie"
    ],
    "maple syrup": [
      "van vleet"
    ],
    "maraschino cherry": [
      "hunter's moon"
    ],
    "maraschino liqueur": [
      "aviation",
      "brooklyn",
      "casino",
      "casino royale",
      "hemingway special",
      "london town",
      "martinez 2",
      "mary pickford",
      "the last word",
      "tuxedo cocktail"
    ],
    "maui": [
      "arctic mouthwash"
    ],
    "melon liqueur": [
      "the philosopher"
    ],
    "mezcal": [
      "empellón cocina's fat-washed mezcal"
    ],
    "midori melon liqueur": [
      "a splash of nash",
      "absolut sex",
      "amaretto sweet & sour",
      "applejack",
      "arizona antifreeze",
      "bob marley",
      "quick f**k",
      "zimadori zinger"
    ],
    "milk": [
      "baby eskimo",
      "banana milk shake",
      "boozy snickers milkshake",
      "butter baby",
      "cafe savoy",
      "chocolate beverage",
      "chocolate drink",
      "chocolate milk",
      "drinking chocolate",
      "egg cream",
      "egg nog #4",
      "frappé",
      "just a moonmint",
      "mother's milk",
      "nutty irishman",
      "orange scented hot chocolate",
      "rum milk punch",
      "spanish chocolate",
      "sweet bananas",
      "sweet tooth"
    ],
    "mint syrup": [
      "just a moonmint"
    ],
    "mint": [
      "derby",
      "frozen mint daiquiri",
      "mango mojito",
      "mint julep",
      "mojito extra",
      "raspberry julep",
      "smashed watermelon margarita"
    ],
    "mountain dew": [
      "arctic mouthwash",
      "brain fart"
    ],
    "olive": [
      "dry martini",
      "martini",
      "vodka martini"
    ],
    "orange bitters": [
      "abbey cocktail",
      "adonis cocktail",
      "alaska cocktail",
      "bijou",
      "highland fling cocktail",
      "london town",
      "sloe gin cocktail",
      "the philosopher",
      "valencia cocktail"
    ],
    "orange curacao": [
      "9 1/2 weeks",
      "pegu club"
    ],
    "orange juice": [
      "50/50",
      "a day at the beach",
      "a gilligan's island",
      "a night in old mandalay",
      "abbey martini",
      "abilene",
      "absolutly screwed up",
      "addison special",
      "affair",
      "after sex",
      "afterglow",
      "alice cocktail",
      "amaretto fizz",
      "amaretto stone sour",
      "amaretto sunrise",
      "apello",
      "arctic fish",
      "autumn garibaldi",
      "banana milk shake",
      "bee's knees",
      "berry deadly",
      "bubble gum",
      "darkwood sling",
      "fruit shake",
      "garibaldi negroni",
      "golden dream",
      "harvey wallbanger",
      "irish spring",
      "lunch box",
      "mimosa",
      "monkey gland",
      "mudslinger",
      "orange crush",
      "orange oasis",
      "orange push-up",
      "orange rosemary collins",
      "orange whip",
      "orangeade",
      "paradise",
      "planter's punch",
      "planter’s punch",
      "pysch vitamin light",
      "quick-sand",
      "rum runner",
      "rum screwdriver",
      "sangria",
      "screwdriver",
      "spiced peach punch",
      "stone sour",
      "sunny holiday punch",
      "tequila sunrise",
      "thriller",
      "valencia cocktail",
      "vampiro",
      "wine punch"
    ],
    "orange peel": [
      "halloween punch",
      "orange scented hot chocolate"
    ],
    "orange": [
      "abbey cocktail",
      "bleeding surgeon",
      "caribbean orange liqueur",
      "mango orange smoothie"
    ],
    "orgeat syrup": [
      "mai tai",
      "planter's punch"
    ],
    "ouzo": [
      "surf city lifesaver",
      "zorbatini"
    ],
    "papaya": [
      "kiwi papaya smoothie"
    ],
    "passion fruit juice": [
      "bora bora",
      "ipamena",
      "passion fruit martini",
      "pornstar martini"
    ],
    "passion fruit syrup": [
      "atlantic sun"
    ],
    "passoa": [
      "blue hurricane",
      "pornstar martini",
      "pure passion"
    ],
    "peach brandy": [
      "irish spring"
    ],
    "peach nectar": [
      "abilene",
      "bellini martini",
      "spiced peach punch"
    ],
    "peach schnapps": [
      "a gilligan's island",
      "absolut stress #2",
      "bellini",
      "fuzzy asshole",
      "grand blue",
      "pink penocha",
      "royal flush",
      "sex on the beach",
      "smut"
    ],
    "peach vodka": [
      "410 gone",
      "gagliardo"
    ],
    "peachtree schnapps": [
      "bruised heart",
      "zinger"
    ],
    "peppermint schnapps": [
      "after five"
    ],
    "pepsi cola": [
      "mudslinger",
      "smut"
    ],
    "peychaud bitters": [
      "sazerac"
    ],
    "pina colada mix": [
      "miami vice"
    ],
    "pineapple juice": [
      "afterglow",
      "alfie cocktail",
      "algonquin",
      "alice cocktail",
      "aquamarine",
      "banana cream pi",
      "barracuda",
      "bora bora",
      "cranberry punch",
      "french martini",
      "grass skirt",
      "havana cocktail",
      "hawaiian cocktail",
      "mary pickford",
      "planter’s punch",
      "pysch vitamin light",
      "space odyssey",
      "sunny holiday punch",
      "turkeyball",
      "waikiki beachcomber"
    ],
    "pineapple": [
      "frozen pineapple daiquiri",
      "grape lemon pineapple smoothie",
      "pina colada",
      "pineapple gingerale smoothie"
    ],
    "pink lemonade": [
      "pink panty pulldowns"
    ],
    "pisang ambon": [
      "absolut evergreen",
      "avalon"
    ],
    "pisco": [
      "duchamp's punch",
      "pisco sour"
    ],
    "port": [
      "chicago fizz",
      "port wine cocktail",
      "port wine flip",
      "porto flip"
    ],
    "powdered sugar": [
      "boston sour",
      "brandy sour",
      "daiquiri",
      "gin cooler",
      "gin fizz",
      "gin sling",
      "gin squirt",
      "gin toddy",
      "japanese fizz",
      "lady love fizz",
      "mint julep",
      "port wine flip",
      "royal gin fizz",
      "rum milk punch",
      "rum old-fashioned",
      "rum toddy",
      "scotch sour",
      "sherry eggnog",
      "sherry flip",
      "tequila sour",
      "whiskey sour"
    ],
    "raspberry liqueur": [
      "french martini"
    ],
    "raspberry syrup": [
      "raspberry julep"
    ],
    "raspberry vodka": [
      "butterfly effect",
      "raspberry cooler"
    ],
    "red chili flakes": [
      "halloween punch"
    ],
    "red wine": [
      "artillery punch",
      "gluehwein",
      "queen charlotte",
      "sangria",
      "smut",
      "sweet sangria",
      "wine cooler",
      "wine punch"
    ],
    "ricard": [
      "sazerac"
    ],
    "root beer": [
      "black and brown",
      "zambeer",
      "zenmeister",
      "zoksel"
    ],
    "roses sweetened lime juice": [
      "747 drink"
    ],
    "rumple minze": [
      "24k nightmare"
    ],
    "rye whiskey": [
      "artillery punch",
      "boulevardier",
      "brooklyn",
      "old pal"
    ],
    "salt": [
      "egg-nog - classic cooked",
      "lassi khara",
      "microwave hot cocoa",
      "salty dog"
    ],
    "sambuca": [
      "b-53",
      "brainteaser",
      "bumble bee",
      "dirty nipple",
      "flaming lamborghini",
      "flander's flake-out",
      "freddy kruger",
      "slippery nipple",
      "zambeer",
      "zorro"
    ],
    "sarsaparilla": [
      "flander's flake-out"
    ],
    "schweppes russchian": [
      "kiss me quick",
      "vodka russian"
    ],
    "sherbet": [
      "holloween punch"
    ],
    "sherry": [
      "adonis cocktail",
      "quarter deck cocktail",
      "queen bee",
      "sherry eggnog",
      "sherry flip"
    ],
    "sloe gin": [
      "alabama slammer",
      "blackthorn",
      "clove cocktail",
      "kool-aid shot",
      "sloe gin cocktail"
    ],
    "soda water": [
      "a splash of nash",
      "addington",
      "aperol spritz",
      "autodafé",
      "california root beer",
      "darkwood sling",
      "egg cream",
      "gin and soda",
      "lazy coconut paloma",
      "lemon elderflower spritzer",
      "limeade",
      "spritz",
      "spritz veneziano",
      "zipperhead"
    ],
    "sour mix": [
      "amaretto sour",
      "amaretto stone sour",
      "amaretto stone sour alternative",
      "applejack"
    ],
    "southern comfort": [
      "a piece of ass",
      "a.d.m. (after dinner mint)",
      "alabama slammer",
      "alice in wonderland",
      "atlantic sun",
      "bible belt",
      "mudslinger",
      "texas rattlesnake"
    ],
    "spiced rum": [
      "cream soda",
      "happy skipper",
      "orange push-up"
    ],
    "sprite": [
      "absolut summertime",
      "downshift",
      "pink panty pulldowns",
      "vodka slime"
    ],
    "strawberries": [
      "banana strawberry shake",
      "banana strawberry shake daiquiri",
      "bloody punch",
      "frosé",
      "fruit cooler",
      "strawberry lemonade",
      "strawberry shivers"
    ],
    "strawberry liqueur": [
      "9 1/2 weeks",
      "a midsummernight dream"
    ],
    "strawberry schnapps": [
      "affair",
      "strawberry daiquiri",
      "strawberry margarita"
    ],
    "sugar syrup": [
      "bacardi cocktail",
      "banana milk shake",
      "bramble",
      "espresso martini",
      "gimlet",
      "gin basil smash",
      "hunter's moon",
      "jam donut",
      "kiwi martini",
      "mountain bramble",
      "orangeade",
      "passion fruit martini",
      "rail splitter",
      "ramos gin fizz",
      "russian spring punch"
    ],
    "sugar": [
      "absinthe #2",
      "amaretto liqueur",
      "blueberry mojito",
      "bourbon sling",
      "bourbon sour",
      "brandy cobbler",
      "brandy flip",
      "caipirinha",
      "caipirissima",
      "caribbean orange liqueur",
      "castillian hot chocolate",
      "champagne cocktail",
      "classic old-fashioned",
      "coffee liqueur",
      "coffee-vodka",
      "cranberry cordial",
      "cranberry punch",
      "creme de menthe",
      "egg nog #4",
      "egg nog - healthy",
      "egg-nog - classic cooked",
      "frappé",
      "french 75",
      "frosé",
      "fruit cooler",
      "gin daisy",
      "gin smash",
      "gin sour",
      "gin swizzle",
      "gluehwein",
      "homemade kahlua",
      "iced coffee",
      "irish coffee",
      "john collins",
      "kurant tea",
      "lassi - mango",
      "lassi - sweet",
      "lassi raita",
      "limeade",
      "microwave hot cocoa",
      "mojito",
      "mulled wine",
      "new york sour",
      "nuked hot chocolate",
      "old fashioned",
      "pisco sour",
      "rum cobbler",
      "rum sour",
      "sangria",
      "sazerac",
      "spice 75",
      "strawberry lemonade",
      "swedish coffee",
      "sweet sangria",
      "thai iced coffee",
      "tom collins"
    ],
    "surge": [
      "bleeding surgeon",
      "zinger"
    ],
    "sweet and sour": [
      "absolut summertime",
      "amaretto sweet & sour",
      "arizona antifreeze",
      "royal fizz",
      "stone sour"
    ],
    "sweet vermouth": [
      "abbey martini",
      "addington",
      "adonis cocktail",
      "affinity",
      "americano",
      "artillery",
      "balmoral",
      "blackthorn",
      "bobby burns cocktail",
      "boulevardier",
      "clove cocktail",
      "english highball",
      "flying scotchman",
      "french negroni",
      "gentleman's club",
      "highland fling cocktail",
      "lone tree cocktail",
      "manhattan",
      "martinez 2",
      "negroni",
      "the strange weaver",
      "tipperary",
      "vesuvio",
      "victor"
    ],
    "tabasco sauce": [
      "brave bull shooter",
      "fahrenheit 5000",
      "tequila surprise"
    ],
    "tea": [
      "amaretto tea",
      "artillery punch",
      "herbal flame",
      "kurant tea",
      "masala chai",
      "thai iced tea"
    ],
    "tennessee whiskey": [
      "jack's vanilla coke"
    ],
    "tia maria": [
      "blue mountain",
      "lord and lady"
    ],
    "tomato juice": [
      "bloody maria",
      "bloody mary",
      "michelada",
      "tomato tang",
      "vampiro"
    ],
    "tonic water": [
      "at&t",
      "gin and tonic",
      "gin tonic",
      "rosemary blue",
      "vodka and tonic",
      "vodka tonic"
    ],
    "triple sec": [
      "absolutly screwed up",
      "acapulco",
      "after dinner cocktail",
      "after supper cocktail",
      "alfie cocktail",
      "amaretto sunset",
      "applecar",
      "apricot lady",
      "banana daiquiri",
      "between the sheets",
      "bible belt",
      "bluebird",
      "boston sidecar",
      "boxcar",
      "cafe savoy",
      "casa blanca",
      "city slicker",
      "corpse reviver",
      "flying dutchman",
      "frozen daiquiri",
      "gideon's green dinosaur",
      "golden dream",
      "grass skirt",
      "hawaiian cocktail",
      "kamikaze",
      "mai tai",
      "margarita",
      "martinez cocktail",
      "orange crush",
      "orgasm",
      "sidecar cocktail",
      "strawberry margarita",
      "waikiki beachcomber",
      "white lady",
      "yellow bird"
    ],
    "tropicana": [
      "malibu twister"
    ],
    "vanilla extract": [
      "coffee liqueur",
      "hot chocolate to die for",
      "jack's vanilla coke",
      "nuked hot chocolate"
    ],
    "vanilla ice-cream": [
      "baby eskimo",
      "bailey's dream shake",
      "boozy snickers milkshake",
      "brandon and will's coke float",
      "butter baby"
    ],
    "vanilla syrup": [
      "espresso rumtini"
    ],
    "vanilla vodka": [
      "50/50"
    ],
    "vermouth": [
      "addison",
      "hunter's moon",
      "ziemes martini apfelsaft"
    ],
    "water": [
      "adam sunrise",
      "aloha fruit punch",
      "amaretto liqueur",
      "bourbon sling",
      "chocolate drink",
      "classic old-fashioned",
      "coffee-vodka",
      "creme de menthe",
      "gin toddy",
      "gluehwein",
      "iced coffee",
      "jamaican coffee",
      "jello shots",
      "kill the cold smoothie",
      "lassi - a south indian drink",
      "lassi - sweet",
      "lassi khara",
      "lemouroudji",
      "masala chai",
      "mulled wine",
      "shark attack",
      "strawberry shivers",
      "sweet sangria",
      "thai iced tea",
      "tia-maria"
    ],
    "whipped cream": [
      "amaretto tea"
    ],
    "white creme de menthe": [
      "a.d.m. (after dinner mint)",
      "amaretto stinger",
      "midnight mint",
      "stinger",
      "zorro"
    ],
    "white rum": [
      "caipirissima",
      "honey bee",
      "yellow bird"
    ],
    "white wine": [
      "amaretto fizz",
      "white wine sangria"
    ],
    "wild turkey": [
      "252",
      "acid",
      "shot-gun",
      "turkeyball"
    ],
    "wine": [
      "archbishop",
      "berry deadly",
      "clove cocktail",
      "thriller",
      "whisky mac"
    ],
    "yellow chartreuse": [
      "alaska cocktail",
      "jewel of the nile"
    ],
    "yoghurt": [
      "banana strawberry shake",
      "fruit flip-flop",
      "fruit shake",
      "lassi - a south indian drink",
      "lassi - mango",
      "lassi - sweet",
      "lassi khara",
      "lassi raita",
      "yoghurt cooler"
    ],
    "yukon jack": [
      "texas rattlesnake"
    ],
    "zima": [
      "zima blaster",
      "zimadori zinger"
    ],
    "lillet blanc": [
      "corpse reviver",
      "vesper"
    ],
    "peach bitters": [
      "derby"
    ],
    "prosecco": [
      "aperol spritz",
      "spritz",
      "spritz veneziano"
    ],
    "fresh lime juice": [
      "bombay cassis",
      "pineapple paloma"
    ],
    "elderflower cordial": [
      "elderflower caipirinha",
      "lemon elderflower spritzer",
      "pink moon",
      "the laverstoke"
    ],
    "rosso vermouth": [
      "the laverstoke"
    ],
    "falernum": [
      "corn n oil"
    ],
    "honey syrup": [
      "penicillin"
    ],
    "blended scotch": [
      "penicillin"
    ],
    "151 proof rum": [
      "151 florida bushwacker",
      "252",
      "acid",
      "broadside",
      "flaming dr. pepper",
      "grim reaper",
      "kool first aid",
      "miami vice",
      "rum old-fashioned",
      "space odyssey",
      "zombie"
    ],
    "7-up": [
      "69 special",
      "apple slammer",
      "radler",
      "tequila slammer"
    ],
    "absinthe": [
      "death in the afternoon",
      "moranguito"
    ],
    "absolut citron": [
      "9 1/2 weeks",
      "absolut evergreen",
      "absolut limousine",
      "absolut summertime",
      "absolutly screwed up",
      "cosmopolitan",
      "lemon shot",
      "new york lemonade"
    ],
    "olive brine": [
      "dirty martini"
    ],
    "pineapple syrup": [
      "duchamp's punch"
    ],
    "whiskey": [
      "damned if you do",
      "hot toddy",
      "owen's grandmother's revenge"
    ],
    "whisky": [
      "h.d."
    ],
    "pomegranate juice": [
      "funk and soul"
    ],
    "watermelon": [
      "smashed watermelon margarita"
    ],
    "figs": [
      "figgy thyme"
    ],
    "amaro montenegro": [
      "snowday"
    ],
    "ruby port": [
      "snowday"
    ],
    "rose": [
      "frosé"
    ]
  };


var raw_ing = [
    "vodka",
    "gin",
    "rum",
    "tequila",
    "scotch",
    "absolut kurant",
    "absolut peppar",
    "absolut vodka",
    "advocaat",
    "aejo rum",
    "aftershock",
    "agave syrup",
    "ale",
    "allspice",
    "almond flavoring",
    "almond",
    "amaretto",
    "angelica root",
    "angostura bitters",
    "anis",
    "anise",
    "anisette",
    "aperol",
    "apfelkorn",
    "apple brandy",
    "apple cider",
    "apple juice",
    "apple schnapps",
    "apple",
    "applejack",
    "apricot brandy",
    "apricot nectar",
    "apricot",
    "aquavit",
    "asafoetida",
    "añejo rum",
    "bacardi limon",
    "bacardi",
    "baileys irish cream",
    "banana liqueur",
    "banana rum",
    "banana syrup",
    "banana",
    "barenjager",
    "basil",
    "beef stock",
    "beer",
    "benedictine",
    "berries",
    "bitter lemon",
    "bitters",
    "black pepper",
    "black rum",
    "black sambuca",
    "blackberries",
    "blackberry brandy",
    "blackberry schnapps",
    "blackcurrant cordial",
    "blackcurrant schnapps",
    "blackcurrant squash",
    "blended whiskey",
    "blue curacao",
    "blue maui",
    "blueberries",
    "blueberry schnapps",
    "bourbon",
    "brandy",
    "brown sugar",
    "butter",
    "butterscotch schnapps",
    "cachaca",
    "calvados",
    "campari",
    "canadian whisky",
    "candy",
    "cantaloupe",
    "caramel coloring",
    "carbonated soft drink",
    "carbonated water",
    "cardamom",
    "cayenne pepper",
    "celery salt",
    "celery",
    "chambord raspberry liqueur",
    "champagne",
    "cherries",
    "cherry brandy",
    "cherry cola",
    "cherry grenadine",
    "cherry heering",
    "cherry juice",
    "cherry liqueur",
    "cherry",
    "chocolate ice-cream",
    "chocolate liqueur",
    "chocolate milk",
    "chocolate syrup",
    "chocolate",
    "cider",
    "cinnamon schnapps",
    "cinnamon",
    "citrus vodka",
    "clamato juice",
    "cloves",
    "club soda",
    "coca-cola",
    "cocktail onion",
    "cocoa powder",
    "coconut cream",
    "coconut liqueur",
    "coconut milk",
    "coconut rum",
    "coconut syrup",
    "coffee brandy",
    "coffee liqueur",
    "coffee",
    "cognac",
    "cointreau",
    "cola",
    "cold water",
    "condensed milk",
    "coriander",
    "corn syrup",
    "cornstarch",
    "corona",
    "cranberries",
    "cranberry juice",
    "cranberry liqueur",
    "cranberry vodka",
    "cream of coconut",
    "cream sherry",
    "cream soda",
    "cream",
    "creme de almond",
    "creme de banane",
    "creme de cacao",
    "creme de cassis",
    "creme de noyaux",
    "creme fraiche",
    "crown royal",
    "crystal light",
    "cucumber",
    "cumin powder",
    "cumin seed",
    "curacao",
    "cynar",
    "daiquiri mix",
    "dark chocolate",
    "dark creme de cacao",
    "dark rum",
    "dark soy sauce",
    "demerara sugar",
    "dr. pepper",
    "drambuie",
    "dried oregano",
    "dry vermouth",
    "dubonnet blanc",
    "dubonnet rouge",
    "egg white",
    "egg yolk",
    "egg",
    "eggnog",
    "erin cream",
    "espresso",
    "everclear",
    "fanta",
    "fennel seeds",
    "firewater",
    "flaked almonds",
    "food coloring",
    "forbidden fruit",
    "frangelico",
    "fresca",
    "fresh basil",
    "fresh lemon juice",
    "fruit juice",
    "fruit punch",
    "fruit",
    "galliano",
    "garlic sauce",
    "gatorade",
    "ginger ale",
    "ginger beer",
    "ginger",
    "glycerine",
    "godiva liqueur",
    "gold rum",
    "gold tequila",
    "goldschlager",
    "grain alcohol",
    "grand marnier",
    "granulated sugar",
    "grape juice",
    "grape soda",
    "grapefruit juice",
    "grapes",
    "green chartreuse",
    "green creme de menthe",
    "green ginger wine",
    "green olives",
    "grenadine",
    "ground ginger",
    "guava juice",
    "guinness stout",
    "guinness",
    "half-and-half",
    "hawaiian punch",
    "hazelnut liqueur",
    "heavy cream",
    "honey",
    "hooch",
    "hot chocolate",
    "hot damn",
    "hot sauce",
    "hpnotiq",
    "ice-cream",
    "ice",
    "iced tea",
    "irish cream",
    "irish whiskey",
    "jack daniels",
    "jello",
    "jelly",
    "jagermeister",
    "jim beam",
    "johnnie walker",
    "kahlua",
    "key largo schnapps",
    "kirschwasser",
    "kiwi liqueur",
    "kiwi",
    "kool-aid",
    "kummel",
    "lager",
    "lemon juice",
    "lemon peel",
    "lemon soda",
    "lemon vodka",
    "lemon-lime soda",
    "lemon-lime",
    "lemon",
    "lemonade",
    "licorice root",
    "light cream",
    "light rum",
    "lillet",
    "lime juice cordial",
    "lime juice",
    "lime liqueur",
    "lime peel",
    "lime vodka",
    "lime",
    "limeade",
    "madeira",
    "malibu rum",
    "mandarin",
    "mandarine napoleon",
    "mango",
    "maple syrup",
    "maraschino cherry juice",
    "maraschino cherry",
    "maraschino liqueur",
    "margarita mix",
    "marjoram leaves",
    "marshmallows",
    "maui",
    "melon liqueur",
    "melon vodka",
    "mezcal",
    "midori melon liqueur",
    "midori",
    "milk",
    "mint syrup",
    "mint",
    "mountain dew",
    "nutmeg",
    "olive oil",
    "olive",
    "onion",
    "orange bitters",
    "orange curacao",
    "orange juice",
    "orange liqueur",
    "orange peel",
    "orange rum",
    "orange soda",
    "orange spiral",
    "orange vodka",
    "orange",
    "oreo cookie",
    "orgeat syrup",
    "ouzo",
    "oyster sauce",
    "papaya juice",
    "papaya",
    "parfait amour",
    "passion fruit juice",
    "passion fruit syrup",
    "passoa",
    "peach brandy",
    "peach juice",
    "peach liqueur",
    "peach nectar",
    "peach schnapps",
    "peach vodka",
    "peach",
    "peachtree schnapps",
    "peanut oil",
    "pepper",
    "peppermint extract",
    "peppermint schnapps",
    "pepsi cola",
    "pernod",
    "peychaud bitters",
    "pina colada mix",
    "pineapple juice",
    "pineapple rum",
    "pineapple vodka",
    "pineapple-orange-banana juice",
    "pineapple",
    "pink lemonade",
    "pisang ambon",
    "pisco",
    "plain chocolate",
    "plain flour",
    "plums",
    "port",
    "powdered sugar",
    "purple passion",
    "raisins",
    "raspberry cordial",
    "raspberry jam",
    "raspberry juice",
    "raspberry liqueur",
    "raspberry schnapps",
    "raspberry syrup",
    "raspberry vodka",
    "red chile flakes",
    "red chili flakes",
    "red hot chili flakes",
    "red wine",
    "rhubarb",
    "ricard",
    "rock salt",
    "root beer schnapps",
    "root beer",
    "roses sweetened lime juice",
    "rosewater",
    "rumple minze",
    "rye whiskey",
    "sake",
    "salt",
    "sambuca",
    "sarsaparilla",
    "schnapps",
    "schweppes lemon",
    "schweppes russchian",
    "sherbet",
    "sherry",
    "sirup of roses",
    "sloe gin",
    "soda water",
    "sour apple pucker",
    "sour mix",
    "southern comfort",
    "soy milk",
    "soy sauce",
    "soya milk",
    "soya sauce",
    "spiced rum",
    "sprite",
    "squeezed orange",
    "squirt",
    "strawberries",
    "strawberry juice",
    "strawberry liqueur",
    "strawberry schnapps",
    "strawberry syrup",
    "sugar syrup",
    "sugar",
    "sunny delight",
    "surge",
    "swedish punsch",
    "sweet and sour",
    "sweet cream",
    "sweet vermouth",
    "tabasco sauce",
    "tang",
    "tawny port",
    "tea",
    "tennessee whiskey",
    "tequila rose",
    "tia maria",
    "tomato juice",
    "tomato",
    "tonic water",
    "triple sec",
    "tropicana",
    "tuaca",
    "vanilla extract",
    "vanilla ice-cream",
    "vanilla liqueur",
    "vanilla schnapps",
    "vanilla syrup",
    "vanilla vodka",
    "vanilla",
    "vermouth",
    "vinegar",
    "water",
    "watermelon schnapps",
    "whipped cream",
    "whipping cream",
    "white chocolate liqueur",
    "white creme de menthe",
    "white grape juice",
    "white port",
    "white rum",
    "white vinegar",
    "white wine",
    "wild turkey",
    "wildberry schnapps",
    "wine",
    "worcestershire sauce",
    "wormwood",
    "yeast",
    "yellow chartreuse",
    "yoghurt",
    "yukon jack",
    "zima",
    "caramel sauce",
    "chocolate sauce",
    "lillet blanc",
    "peach bitters",
    "mini-snickers bars",
    "prosecco",
    "salted chocolate",
    "martini rosso",
    "martini bianco",
    "martini extra dry",
    "fresh lime juice",
    "fresh mint",
    "rosemary",
    "habanero peppers",
    "ilegal joven mezcal",
    "elderflower cordial",
    "rosso vermouth",
    "creme de violette",
    "cocchi americano",
    "white vermouth",
    "dry curacao",
    "nocino",
    "averna",
    "ramazzotti",
    "fernet-branca",
    "allspice dram",
    "falernum",
    "singani",
    "arrack",
    "blackstrap rum",
    "ginger syrup",
    "honey syrup",
    "blended scotch",
    "islay single malt scotch",
    "151 proof rum",
    "7-up",
    "absinthe",
    "absolut citron",
    "creme de mure",
    "olive brine",
    "pineapple syrup",
    "st. germain",
    "lavender",
    "whiskey",
    "whisky",
    "pomegranate juice",
    "watermelon",
    "chareau",
    "cinnamon whisky",
    "red bull",
    "diet coke",
    "rosemary syrup",
    "figs",
    "thyme",
    "orange slice",
    "blood orange",
    "amaro montenegro",
    "ruby port",
    "rose",
    "tajin"
  ]

  var drink_ID = {'3 wise men': '13899', '3-mile long island iced tea': '15300', '9 1/2 weeks': '16108', '24k nightmare': '17060', '50/50': '14598', '57 chevy with a white license plate': '14029', '69 special': '13940', '110 in the shade': '15423', '151 florida bushwacker': '14588', '155 belmont': '15346', '252': '15288', '410 gone': '13581', '501 blue': '17105', '747 drink': '178318', '747': '14229', 'a1': '17222', 'a day at the beach': '15200', 'a furlong too late': '17831', "a gilligan's island": '16943', 'a midsummernight dream': '15675', 'a night in old mandalay': '17832', 'a piece of ass': '16405', 'a splash of nash': '14564', 'a true amaretto sour': '17005', 'a. j.': '17833', 'a.d.m. (after dinner mint)': '14560', 'abbey cocktail': '17834', 'abbey martini': '17223', 'abc': '13501', 'abilene': '17835', 'absinthe #2': '12790', 'absolut evergreen': '14374', 'absolut limousine': '14372', 'absolut sex': '14360', 'absolut stress #2': '15597', 'absolut summertime': '14107', 'absolutely cranberry smash': '15024', 'absolutely fabulous': '17224', 'absolutly screwed up': '16134', 'acapulco': '17836', 'ace': '17225', 'acid': '14610', 'adam & eve': '16333', 'adam bomb': '16333', 'adam sunrise': '15567', 'adam': '17837', 'addington': '17227', 'addison special': '14272', 'addison': '17228', 'adios amigos cocktail': '17229', 'adonis cocktail': '17838', 'affair': '17839', 'affinity': '17840', 'after dinner cocktail': '11010', 'after five': '13807', 'after sex': '15182', 'after supper cocktail': '11011', 'afterglow': '12560', 'afternoon': '13162', 'alabama slammer': '11012', 'alaska cocktail': '11013', 'alexander': '11014', 'alfie cocktail': '11019', 'algonquin': '11020', 'alice cocktail': '12562', 'alice in wonderland': '17094', 'allegheny': '11021', 'allies cocktail': '11022', 'almeria': '11023', 'almond chocolate coffee': '16082', 'almond joy': '11024', 'aloha fruit punch': '12862', 'amaretto and cream': '11025', 'amaretto fizz': '178321', 'amaretto liqueur': '12792', 'amaretto mist': '11026', 'amaretto rose': '11027', 'amaretto shake': '15194', 'amaretto sour': '13731', 'amaretto stinger': '11028', 'amaretto stone sour alternative': '16100', 'amaretto stone sour': '14306', 'amaretto sunrise': '14578', 'amaretto sunset': '17168', 'amaretto sweet & sour': '16202', 'amaretto tea': '11029', 'americano': '15941', 'angel face': '11034', 'angelica liqueur': '12794', 'apello': '15106', 'aperol spritz': '178325', 'apple berry smoothie': '12710', 'apple cider punch': '12864', 'apple grande': '16289', 'apple highball': '178353', 'apple karate': '12564', 'apple pie with a crust': '16958', 'apple slammer': '13683', 'applecar': '11046', 'applejack': '16311', 'apricot lady': '11050', 'apricot punch': '15849', 'aquamarine': '178319', 'archbishop': '11052', 'arctic fish': '14622', 'arctic mouthwash': '17118', 'arise my love': '11053', 'arizona antifreeze': '16354', 'arizona stingers': '14584', 'arizona twister': '17074', 'army special': '17066', 'arthur tompkins': '11054', 'artillery punch': '12870', 'artillery': '11055', 'at&t': '13938', 'atlantic sun': '13423', 'atomic lokade': '13086', 'auburn headbanger': '17020', 'autodaé': '12756', 'autumn garibaldi': '178337', 'avalanche': '16419', 'avalon': '15266', 'aviation': '17180', 'aztec punch': '14364', 'b-52': '15853', 'b-53': '13332', 'baby eskimo': '15511', 'baby guinness': '17079', 'bacardi cocktail': '17183', 'bahama mama': '17267', "bailey's dream shake": '14510', 'balmoral': '11060', 'banana cantaloupe smoothie': '12708', 'banana cream pi': '178320', 'banana daiquiri': '11064', 'banana milk shake': '12654', 'banana strawberry shake daiquiri': '12658', 'banana strawberry shake': '12656', 'barracuda': '17209', "bee's knees": '178317', 'belgian blue': '14071', 'bellini martini': '16176', 'bellini': '17195', 'bermuda highball': '11084', 'berry deadly': '12876', 'between the sheets': '17184', 'bible belt': '16986', 'big red': '13222', 'bijou': '17254', 'black & tan': '13282', 'black and brown': '16403', 'black forest shake': '15951', 'black russian': '11102', 'blackthorn': '11106', 'bleeding surgeon': '16295', 'blind russian': '14356', 'bloody maria': '11112', 'bloody mary': '11113', 'bloody punch': '178312', 'blue hurricane': '17268', 'blue lagoon': '11117', 'blue margarita': '11118', 'blue mountain': '11119', 'blueberry mojito': '178336', 'bluebird': '11120', 'bob marley': '13395', 'bobby burns cocktail': '11121', 'bombay cassis': '17242', 'boomerang': '11124', 'boozy snickers milkshake': '17221', 'bora bora': '12572', 'boston sidecar': '11128', 'boston sour': '11129', 'boulevardier': '17251', 'bounty hunter': '178331', 'bourbon sling': '11146', 'bourbon sour': '11147', 'boxcar': '11149', 'brain fart': '17120', 'brainteaser': '13405', 'bramble': '17210', "brandon and will's coke float": '16447', 'brandy alexander': '11016', 'brandy cobbler': '11157', 'brandy flip': '11164', 'brandy sour': '11170', 'brave bull shooter': '13068', 'brigadier': '17825', 'broadside': '178311', 'brooklyn': '178310', "bruce's puce": '13066', 'bruised heart': '16998', 'bubble gum': '14730', 'buccaneer': '17035', 'bumble bee': '14538', 'butter baby': '17220', 'butterfly effect': '178356', 'cafe savoy': '14181', 'caipirinha': '11202', 'caipirissima': '13206', 'california lemonade': '11205', 'california root beer': '14282', 'campari beer': '16047', "captain kidd's punch": '178329', 'caribbean boilermaker': '17065', 'caribbean orange liqueur': '12796', 'casa blanca': '11222', 'casino royale': '11224', 'casino': '17185', 'castillian hot chocolate': '12730', 'champagne cocktail': '11227', 'cherry electric lemonade': '17174', 'cherry rum': '11239', 'chicago fizz': '11242', 'chocolate beverage': '12732', 'chocolate black russian': '11243', 'chocolate drink': '12734', 'chocolate milk': '13328', 'chocolate monkey': '15615', 'citrus coke': '17135', 'city slicker': '11251', 'classic old-fashioned': '11145', 'clove cocktail': '11255', 'clover club': '17186', 
    "cocktail horse's neck": '178369', 'coffee liqueur': '12798', 'coffee-vodka': '12800', 'coke and drops': '17108', 'corn n oil': '17830', 'corpse reviver': '17250', 'cosmopolitan martini': '14133', 'cosmopolitan': '17196', 'cranberry cordial': '12802', 'cranberry punch': '12890', 'cream soda': '14608', 'creme de menthe': '12808', 'cuba libra': '13751', 'cuba libre': '11288', 'daiquiri': '11006', 'damned if you do': '13194', 'danbooka': '15409', 'dark and stormy': '17211', 'dark caipirinha': '17177', 'darkwood sling': '14482', 'death in the afternoon': '178334', 'derby': '17187', 'diesel': '13128', 'dirty martini': '17181', 'dirty nipple': '14466', 'downshift': '16991', 'dragonfly': '11320', 'drinking chocolate': '12736', 'dry martini': '11005', 'dry rob roy': '11324', 'dubonnet cocktail': '11326', "duchamp's punch": '17182', 'egg cream': '12668', 'egg nog #4': '12910', 'egg nog - healthy': '12916', 'egg-nog - classic cooked': '12914', 'elderflower caipirinha': '178346', "empellón cocina's fat-washed mezcal": '17246', 'english highball': '11338', 'english rose cocktail': '11339', 'espresso martini': '17212', 'espresso rumtini': '178309', 'fahrenheit 5000': '13070', 'figgy thyme': '178344', 'flaming dr. pepper': '13202', 'flaming lamborghini': '16485', "flander's flake-out": '13675', 'flying dutchman': '11368', 'flying scotchman': '11369', 'foxy lady': '11375', 'frappé': '12768', 'freddy kruger': '14688', 'french 75': '17197', 'french connection': '17198', 'french martini': '17213', 'french negroni': '17248', 'frisco sour': '11382', 'frosé': '178352', 'frozen daiquiri': '11387', 'frozen mint daiquiri': '11390', 'frozen pineapple daiquiri': '11391', 'fruit cooler': '12670', 'fruit flip-flop': '12672', 'fruit shake': '12674', 'funk and soul': '178328', 'fuzzy asshole': '15743', 'gagliardo': '12758', 'garibaldi negroni': '178340', "gentleman's club": '11396', 'gg': '15997', "gideon's green dinosaur": '17002', 'gimlet': '17255', 'gin and soda': '178342', 'gin and tonic': '11403', 'gin basil smash': '178314', 'gin cooler': '11407', 'gin daisy': '11408', 'gin fizz': '11410', 'gin lemon': '178366', 'gin rickey': '17230', 'gin sling': '11415', 'gin smash': '11416', 'gin sour': '11417', 'gin squirt': '11418', 'gin swizzle': '11419', 'gin toddy': '11420', 'gin tonic': '178365', 'girl from ipanema': '17175', 'gluehwein': '12944', 'godchild': '11422', 'godfather': '11423', 'godmother': '11424', 'golden dream': '17199', 'grand blue': '15427', 'grape lemon pineapple smoothie': '12712', 'grass skirt': '11433', 'grasshopper': '17200', 'green goblin': '13497', 'greyhound': '17252', 'grim reaper': '14642', 'grizzly bear': '12762', 'h.d.': '16262', 'halloween punch': '178313', 'happy skipper': '12766', 'harvey wallbanger': '11462', 'havana cocktail': '11470', 'hawaiian cocktail': '11472', 'hemingway special': '17201', 'herbal flame': '15813', 'highland fling cocktail': '11476', 'holloween punch': '12954', 'homemade kahlua': '17044', 'honey bee': '178316', "horse's neck": '17202', 'hot chocolate to die for': '12738', 'hot creamy bush': '14782', 'hot toddy': '178345', "hunter's moon": '17239', 'ice pick': '13539', 'iced coffee fillip': '12772', 'iced coffee': '12770', 'imperial cocktail': '12706', 'imperial fizz': '11524', 'ipamena': '17176', 'irish coffee': '13971', 'irish cream': '12820', 'irish curdling cow': '16987', 'irish russian': '17015', 'irish spring': '11528', 'jack rose cocktail': '11542', "jack's vanilla coke": '16275', 'jackhammer': '13847', 'jam donut': '17178', 'jamaica kiss': '14095', 'jamaican coffee': '15825', 'japanese fizz': '11558', 'jello shots': '14956', 'jelly bean': '13775', 'jewel of the nile': '11566', 'jitterbug': '16178', 'john collins': '11580', 'just a moonmint': '12688', 'kamikaze': '11600', 'karsk': '12764', 'kentucky b and b': '11602', 'kentucky colonel': '11604', 'kill the cold smoothie': '12720', 'kioki coffee': '16951', 'kir royale': '13837', 'kir': '17203', 'kiss me quick': '15026', 'kiwi lemon': '14752', 'kiwi martini': '178359', 'kiwi papaya smoothie': '12714', 'kool first aid': '17006', 'kool-aid shot': '13190', 'kool-aid slammer': '14446', 'kurant tea': '14456', 'lady love fizz': '11634', 'lassi - a south indian drink': '12690', 'lassi - mango': '12698', 'lassi - sweet': '12696', 'lassi khara': '12692', 'lassi raita': '12694', 'lazy coconut paloma': '178335', 'lemon drop': '14366', 'lemon elderflower spritzer': '178360', 'lemon shot': '12752', 'lemouroudji': '12702', 'limeade': '12704', 'limona corona': '15086', 'loch lomond': '11658', 'london town': '11662', 'lone tree cocktail': '11664', 'lone tree cooler': '11666', 'long island iced tea': '17204', 'long island tea': '11002', 'long vodka': '13196', 'lord and lady': '11670', 'lunch box': '14378', 'mai tai': '11690', 'malibu twister': '15224', 'mango mojito': '178358', 'mango orange smoothie': '12716', 'manhattan': '11008', 'margarita': '11007', 'martinez 2': '17256', 'martinez cocktail': '11720', 'martini': '11728', 'mary pickford': '17188', 'masala chai': '12774', 'melya': '12776', 'miami vice': '13936', 'michelada': '178343', 'microwave hot cocoa': '12744', 'midnight cowboy': '11766', 'midnight manx': '13825', 'midnight mint': '14842', 'mimosa': '17205', 'mint julep': '17206', "mississippi planters punch": '11786', 'mocha-berry': '14209', 'mojito extra': '15841', 'mojito': '11000', 'monkey gland': '17189', 'monkey wrench': '11798', 'moranguito': '16196', 'moscow mule': '11009', "mother's milk": '14053', 'mountain bramble': '178355', 'mudslinger': '16041', 'mulled wine': '12988', 'munich mule': '178315', 'national aquarium': '13192', 'negroni': '11003', 'new york lemonade': '13204', 'new york sour': '11844', 'nuked hot chocolate': '12746', 'nutty irishman': '13861', 'oatmeal cookie': '17266', 'old fashioned': '11001', 'old pal': '17827', 'orange crush': '15330', 'orange oasis': '11870', 'orange push-up': '14586', 'orange rosemary collins': '178341', 'orange scented hot chocolate': '12748', 'orange whip': '16995', 'orangeade': '12618', 'oreo mudslide': '13499', 'orgasm': '11872', "owen's grandmother's revenge": '13200', 'paloma': '17253', 'paradise': '17190', 'passion fruit martini': '178323', 'pegu club': '17249', 'penicillin': '17829', 'pina colada': '17207', 'pineapple gingerale smoothie': '12718', 'pineapple paloma': '178327', 'pink gin': '11936', 'pink lady': '11938', 'pink moon': '178354', 'pink panty pulldowns': '13535', 'pink penocha': '16992', 'pisco sour': '13214', "planter's punch": '17191', "planter's punch": '178368', 'popped cherry': '13072', 'poppy cocktail': '11959', 'pornstar martini': '178357', 'port and starboard': '11961', 'port wine cocktail': '11963', 'port wine flip': '11965', 'porto flip': '17192', 'pure passion': '178338', 'pysch vitamin light': '15092', "quaker's cocktail": '11983', 'quarter deck cocktail': '11985', 'queen bee': '11987', 'queen charlotte': '11989', 'queen elizabeth': '11991', 'quentin': '11993', 'quick f**k': '13198', 'quick-sand': '15761', 'radioactive long island iced tea': '16984', 'radler': '16031', 'rail splitter': '12630', 'ramos gin fizz': '178367', 'raspberry cooler': '17167', 'raspberry julep': '178333', 'red snapper': '14087', 'rose': '17208', 'rosemary blue': '17245', 'royal bitch': '17122', 'royal fizz': '12055', 'royal flush': '15082', 'royal gin fizz': '12057', 'ruby tuesday': '17114', 'rum cobbler': '12067', 'rum cooler': '12071', 'rum milk punch': '12087', 'rum old-fashioned': '12089', 'rum punch': '14978', 'rum runner': '16250', 'rum screwdriver': '12091', 'rum sour': '12093', 'rum toddy': '12097', 'russian spring punch': '17214', 'rusty nail': '12101', 'salted toffee martini': '17233', 'salty dog': '12107', 'san francisco': '15184', 'sangria': '13020', 'sazerac': '12127', 'scooter': '12130', 'scotch cobbler': '12138', 'scotch sour': '12158', 'scottish highland liqueur': '12854', 'screaming orgasm': '13625', 'screwdriver': '12162', 'sea breeze': '13377', 'sex on the beach': '12754', 'shanghai cocktail': '12186', 'shark attack': '16273', 'sherry eggnog': '12188', 'sherry flip': '12190', 'shot-gun': '16985', 'sidecar cocktail': '12198', 'sidecar': '12196', 'singapore sling': '12214', 'slippery nipple': '178306', 'sloe gin cocktail': '12224', 'smashed watermelon margarita': '178332', 'smut': '17141', 'snake bite (uk)': '13389', 'snakebite and black': '15789', 'snowball': '14195', 'snowday': '178349', 'sol y sombra': '12256', 'space odyssey': '15226', 'spanish chocolate': '12750', 'spice 75': '178322', 'spiced peach punch': '13032', 'spiking coffee': '12780', 'spritz veneziano': '178308', 'spritz': '17215', 'stinger': '17193', 'stone sour': '12308', 'strawberry daiquiri': '12316', 'strawberry lemonade': '13036', 'strawberry margarita': '12322', 'strawberry shivers': '12722', 'sunny holiday punch': '13042', 'surf city lifesaver': '12760', 'swedish coffee': '15521', 'sweet bananas': '12724', 'sweet sangria': '13024', 'sweet tooth': '16990', 'talos coffee': '14860', 'tennesee mud': '15515', 'tequila fizz': '12362', 'tequila slammer': '178307', 'tequila sour': '12370', 'tequila sunrise': '13621', 'tequila surprise': '14602', 'texas rattlesnake': '15178', 'texas sling': '15639', 'thai coffee': '12782', 'thai iced coffee': '12784', 'thai iced tea': '12786', 'the evil blue thing': '16271', 'the galah': '178350', 'the jimmy conway': '17826', 'the last word': '17247', 'the laverstoke': '17824', 'the philosopher': '178330', 'the strange weaver': '178339', 'thriller': '12388', 'tia-maria': '12856', 'tipperary': '17828', 'tom collins': '12402', 'tomato tang': '12726', "tommy's margarita": '17216', 'turf cocktail': '12418', 'turkeyball': '15006', 'tuxedo cocktail': '12420', 'valencia cocktail': '12434', 'vampiro': '17217', 'van vleet': '12436', 'vermouth cassis': '12442', 'vesper': '17218', 'vesuvio': '12444', 'veteran': '12446', 'victor': '12450', 'victory collins': '12452', 'vodka and tonic': '12460', 'vodka fizz': '16967', 'vodka lemon': '178363', 'vodka martini': '14167', 'vodka russian': '15403', 'vodka slime': '178362', 'vodka tonic': '178364', 'waikiki beachcomber': '12474', 'whiskey sour': '11004', 'whisky mac': '12518', 'white lady': '17194', 'white russian': '12528', 'white wine sangria': '178326', 'whitecap margarita': '16158', 'wine cooler': '13056', 'wine punch': '13058', 'winter paloma': '178348', 'winter rita': '178347', 'yellow bird': '17219', 'yoghurt cooler': '12728', 'zambeer': '15933', 'zenmeister': '15254', 'ziemes martini apfelsaft': '14157', 'zima blaster': '17027', 'zimadori zinger': '15801', 'zinger': '14888', 'zipperhead': '16942', "zippy's revenge": '14065', 'zizi coin-coin': '14594', 'zoksel': '15691', 'zombie': '17241', 'zorbatini': '16963', 'zorro': '15328'}


  export function myDrinks() {
    return drinks;
  }

  export function myIngredients() {
    return ingredients;
  }

  export function myRaw_ing() {
    return raw_ing;
  }

  export function myDrink_names(){
    return drink_names;
  }

  export function drinkID(){
    return drink_ID;
  }